var items = {
  "block.minecraft.acacia_button": "Akáciové tlačidlo",
  "block.minecraft.acacia_door": "Akáciové dvere",
  "block.minecraft.acacia_fence": "Akáciový plot",
  "block.minecraft.acacia_fence_gate": "Akáciová bránka",
  "block.minecraft.acacia_hanging_sign": "Akáciová závesná ceduľa",
  "block.minecraft.acacia_leaves": "Akáciové listy",
  "block.minecraft.acacia_log": "Akáciový kmeň",
  "block.minecraft.acacia_planks": "Akáciové dosky",
  "block.minecraft.acacia_pressure_plate": "Akáciová nášľapná doska",
  "block.minecraft.acacia_sapling": "Akáciová sadenica",
  "block.minecraft.acacia_shelf": "Akáciová polička",
  "block.minecraft.acacia_sign": "Akáciová ceduľa",
  "block.minecraft.acacia_slab": "Akáciový stupienok",
  "block.minecraft.acacia_stairs": "Akáciové schody",
  "block.minecraft.acacia_trapdoor": "Akáciový poklop",
  "block.minecraft.acacia_wall_hanging_sign": "Nástenná akáciová závesná ceduľa",
  "block.minecraft.acacia_wall_sign": "Nástenná akáciová ceduľa",
  "block.minecraft.acacia_wood": "Akáciové drevo",
  "block.minecraft.activator_rail": "Aktivačné koľajnice",
  "block.minecraft.air": "Vzduch",
  "block.minecraft.allium": "Okrasný cesnak",
  "block.minecraft.amethyst_block": "Kocka ametystu",
  "block.minecraft.amethyst_cluster": "Ametystový zhluk",
  "block.minecraft.ancient_debris": "Starobylé trosky",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezitový stupienok",
  "block.minecraft.andesite_stairs": "Andezitové schody",
  "block.minecraft.andesite_wall": "Andezitový múr",
  "block.minecraft.anvil": "Nákova",
  "block.minecraft.attached_melon_stem": "Pripojená melónová stonka",
  "block.minecraft.attached_pumpkin_stem": "Pripojená tekvicová stonka",
  "block.minecraft.azalea": "Azalka",
  "block.minecraft.azalea_leaves": "Azalkové listy",
  "block.minecraft.azure_bluet": "Houstónia",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Kocka bambusu",
  "block.minecraft.bamboo_button": "Bambusové tlačidlo",
  "block.minecraft.bamboo_door": "Bambusové dvere",
  "block.minecraft.bamboo_fence": "Bambusový plot",
  "block.minecraft.bamboo_fence_gate": "Bambusová bránka",
  "block.minecraft.bamboo_hanging_sign": "Bambusová závesná ceduľa",
  "block.minecraft.bamboo_mosaic": "Bambusová mozaika",
  "block.minecraft.bamboo_mosaic_slab": "Stupienok z bambusovej mozaiky",
  "block.minecraft.bamboo_mosaic_stairs": "Schody z bambusovej mozaiky",
  "block.minecraft.bamboo_planks": "Bambusové dosky",
  "block.minecraft.bamboo_pressure_plate": "Bambusová nášľapná doska",
  "block.minecraft.bamboo_sapling": "Bambusový výhonok",
  "block.minecraft.bamboo_shelf": "Bambusová polička",
  "block.minecraft.bamboo_sign": "Bambusová ceduľa",
  "block.minecraft.bamboo_slab": "Bambusový stupienok",
  "block.minecraft.bamboo_stairs": "Bambusové schody",
  "block.minecraft.bamboo_trapdoor": "Bambusový poklop",
  "block.minecraft.bamboo_wall_hanging_sign": "Nástenná bambusová závesná ceduľa",
  "block.minecraft.bamboo_wall_sign": "Nástenná bambusová ceduľa",
  "block.minecraft.banner.base.black": "Čierne pole",
  "block.minecraft.banner.base.blue": "Modré pole",
  "block.minecraft.banner.base.brown": "Hnedé pole",
  "block.minecraft.banner.base.cyan": "Tyrkysové pole",
  "block.minecraft.banner.base.gray": "Sivé pole",
  "block.minecraft.banner.base.green": "Zelené pole",
  "block.minecraft.banner.base.light_blue": "Svetlomodré pole",
  "block.minecraft.banner.base.light_gray": "Svetlosivé pole",
  "block.minecraft.banner.base.lime": "Svetlozelené pole",
  "block.minecraft.banner.base.magenta": "Purpurové pole",
  "block.minecraft.banner.base.orange": "Oranžové pole",
  "block.minecraft.banner.base.pink": "Ružové pole",
  "block.minecraft.banner.base.purple": "Fialové pole",
  "block.minecraft.banner.base.red": "Červené pole",
  "block.minecraft.banner.base.white": "Biele pole",
  "block.minecraft.banner.base.yellow": "Žlté pole",
  "block.minecraft.banner.border.black": "Čierny lem",
  "block.minecraft.banner.border.blue": "Modrý lem",
  "block.minecraft.banner.border.brown": "Hnedý lem",
  "block.minecraft.banner.border.cyan": "Tyrkysový lem",
  "block.minecraft.banner.border.gray": "Sivý lem",
  "block.minecraft.banner.border.green": "Zelený lem",
  "block.minecraft.banner.border.light_blue": "Svetlomodrý lem",
  "block.minecraft.banner.border.light_gray": "Svetlosivý lem",
  "block.minecraft.banner.border.lime": "Svetlozelený lem",
  "block.minecraft.banner.border.magenta": "Purpurový lem",
  "block.minecraft.banner.border.orange": "Oranžový lem",
  "block.minecraft.banner.border.pink": "Ružový lem",
  "block.minecraft.banner.border.purple": "Fialový lem",
  "block.minecraft.banner.border.red": "Červený lem",
  "block.minecraft.banner.border.white": "Biely lem",
  "block.minecraft.banner.border.yellow": "Žltý lem",
  "block.minecraft.banner.bricks.black": "Čierne murované pole",
  "block.minecraft.banner.bricks.blue": "Modré murované pole",
  "block.minecraft.banner.bricks.brown": "Hnedé murované pole",
  "block.minecraft.banner.bricks.cyan": "Tyrkysové murované pole",
  "block.minecraft.banner.bricks.gray": "Sivé murované pole",
  "block.minecraft.banner.bricks.green": "Zelené murované pole",
  "block.minecraft.banner.bricks.light_blue": "Svetlomodré murované pole",
  "block.minecraft.banner.bricks.light_gray": "Svetlosivé murované pole",
  "block.minecraft.banner.bricks.lime": "Svetlozelené murované pole",
  "block.minecraft.banner.bricks.magenta": "Purpurové murované pole",
  "block.minecraft.banner.bricks.orange": "Oranžové murované pole",
  "block.minecraft.banner.bricks.pink": "Ružové murované pole",
  "block.minecraft.banner.bricks.purple": "Fialové murované pole",
  "block.minecraft.banner.bricks.red": "Červené murované pole",
  "block.minecraft.banner.bricks.white": "Biele murované pole",
  "block.minecraft.banner.bricks.yellow": "Žlté murované pole",
  "block.minecraft.banner.circle.black": "Čierna guľa",
  "block.minecraft.banner.circle.blue": "Modrá guľa",
  "block.minecraft.banner.circle.brown": "Hnedá guľa",
  "block.minecraft.banner.circle.cyan": "Tyrkysová guľa",
  "block.minecraft.banner.circle.gray": "Sivá guľa",
  "block.minecraft.banner.circle.green": "Zelená guľa",
  "block.minecraft.banner.circle.light_blue": "Svetlomodrá guľa",
  "block.minecraft.banner.circle.light_gray": "Svetlosivá guľa",
  "block.minecraft.banner.circle.lime": "Svetlozelená guľa",
  "block.minecraft.banner.circle.magenta": "Fialová guľa",
  "block.minecraft.banner.circle.orange": "Oranžová guľa",
  "block.minecraft.banner.circle.pink": "Ružová guľa",
  "block.minecraft.banner.circle.purple": "Purpurová guľa",
  "block.minecraft.banner.circle.red": "Červená guľa",
  "block.minecraft.banner.circle.white": "Biela guľa",
  "block.minecraft.banner.circle.yellow": "Žltá guľa",
  "block.minecraft.banner.creeper.black": "Čierny creeper",
  "block.minecraft.banner.creeper.blue": "Modrý creeper",
  "block.minecraft.banner.creeper.brown": "Hnedý creeper",
  "block.minecraft.banner.creeper.cyan": "Tyrkysový creeper",
  "block.minecraft.banner.creeper.gray": "Sivý creeper",
  "block.minecraft.banner.creeper.green": "Zelený creeper",
  "block.minecraft.banner.creeper.light_blue": "Svetlomodrý creeper",
  "block.minecraft.banner.creeper.light_gray": "Svetlosivý creeper",
  "block.minecraft.banner.creeper.lime": "Svetlozelený creeper",
  "block.minecraft.banner.creeper.magenta": "Purpurový creeper",
  "block.minecraft.banner.creeper.orange": "Oranžový creeper",
  "block.minecraft.banner.creeper.pink": "Ružový creeper",
  "block.minecraft.banner.creeper.purple": "Fialový creeper",
  "block.minecraft.banner.creeper.red": "Červený creeper",
  "block.minecraft.banner.creeper.white": "Biely creeper",
  "block.minecraft.banner.creeper.yellow": "Žltý creeper",
  "block.minecraft.banner.cross.black": "Čierny ondrejský kríž",
  "block.minecraft.banner.cross.blue": "Modrý ondrejský kríž",
  "block.minecraft.banner.cross.brown": "Hnedý ondrejský kríž",
  "block.minecraft.banner.cross.cyan": "Tyrkysový ondrejský kríž",
  "block.minecraft.banner.cross.gray": "Sivý ondrejský kríž",
  "block.minecraft.banner.cross.green": "Zelený ondrejský kríž",
  "block.minecraft.banner.cross.light_blue": "Svetlomodrý ondrejský kríž",
  "block.minecraft.banner.cross.light_gray": "Svetlosivý ondrejský kríž",
  "block.minecraft.banner.cross.lime": "Svetlozelený ondrejský kríž",
  "block.minecraft.banner.cross.magenta": "Purpurový ondrejský kríž",
  "block.minecraft.banner.cross.orange": "Oranžový ondrejský kríž",
  "block.minecraft.banner.cross.pink": "Ružový ondrejský kríž",
  "block.minecraft.banner.cross.purple": "Fialový ondrejský kríž",
  "block.minecraft.banner.cross.red": "Červený ondrejský kríž",
  "block.minecraft.banner.cross.white": "Biely ondrejský kríž",
  "block.minecraft.banner.cross.yellow": "Žltý ondrejský kríž",
  "block.minecraft.banner.curly_border.black": "Čierny zúbkovaný lem",
  "block.minecraft.banner.curly_border.blue": "Modrý zúbkovaný lem",
  "block.minecraft.banner.curly_border.brown": "Hnedný zúbkovaný lem",
  "block.minecraft.banner.curly_border.cyan": "Tyrkysový zúbkovaný lem",
  "block.minecraft.banner.curly_border.gray": "Sivý zúbkovaný lem",
  "block.minecraft.banner.curly_border.green": "Zelený zúbkovaný lem",
  "block.minecraft.banner.curly_border.light_blue": "Svetlomodrý zúbkovaný lem",
  "block.minecraft.banner.curly_border.light_gray": "Svetlosivý zúbkovaný lem",
  "block.minecraft.banner.curly_border.lime": "Svetlozelený zúbkovaný lem",
  "block.minecraft.banner.curly_border.magenta": "Purpurový zúbkovaný lem",
  "block.minecraft.banner.curly_border.orange": "Oranžový zúbkovaný lem",
  "block.minecraft.banner.curly_border.pink": "Ružový zúbkovaný lem",
  "block.minecraft.banner.curly_border.purple": "Fialový zúbkovaný lem",
  "block.minecraft.banner.curly_border.red": "Červený zúbkovaný lem",
  "block.minecraft.banner.curly_border.white": "Biely zúbkovaný lem",
  "block.minecraft.banner.curly_border.yellow": "Žltý zúbkovaný lem",
  "block.minecraft.banner.diagonal_left.black": "Čierne šikmo delené pole",
  "block.minecraft.banner.diagonal_left.blue": "Modré šikmo delené pole",
  "block.minecraft.banner.diagonal_left.brown": "Hnedé šikmo delené pole",
  "block.minecraft.banner.diagonal_left.cyan": "Tyrkysové šikmo delené pole",
  "block.minecraft.banner.diagonal_left.gray": "Sivé šikmo delené pole",
  "block.minecraft.banner.diagonal_left.green": "Zelené šikmo delené pole",
  "block.minecraft.banner.diagonal_left.light_blue": "Svetlomodré šikmo delené pole",
  "block.minecraft.banner.diagonal_left.light_gray": "Svetlosivé šikmo delené pole",
  "block.minecraft.banner.diagonal_left.lime": "Svetlozelené šikmo delené pole",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurové šikmo delené pole",
  "block.minecraft.banner.diagonal_left.orange": "Oranžové šikmo delené pole",
  "block.minecraft.banner.diagonal_left.pink": "Ružové šikmo delené pole",
  "block.minecraft.banner.diagonal_left.purple": "Fialové šikmo delené pole",
  "block.minecraft.banner.diagonal_left.red": "Červené šikmo delené pole",
  "block.minecraft.banner.diagonal_left.white": "Biele šikmo delené pole",
  "block.minecraft.banner.diagonal_left.yellow": "Žlté šikmo delené pole",
  "block.minecraft.banner.diagonal_right.black": "Čierne kosmo delené pole",
  "block.minecraft.banner.diagonal_right.blue": "Modré kosmo delené pole",
  "block.minecraft.banner.diagonal_right.brown": "Hnedé kosmo delené pole",
  "block.minecraft.banner.diagonal_right.cyan": "Tyrkysové kosmo delené pole",
  "block.minecraft.banner.diagonal_right.gray": "Sivé kosmo delené pole",
  "block.minecraft.banner.diagonal_right.green": "Zelené kosmo delené pole",
  "block.minecraft.banner.diagonal_right.light_blue": "Svetlomodré kosmo delené pole",
  "block.minecraft.banner.diagonal_right.light_gray": "Svetlosivé kosmo delené pole",
  "block.minecraft.banner.diagonal_right.lime": "Svetlozelené kosmo delené pole",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurové kosmo delené pole",
  "block.minecraft.banner.diagonal_right.orange": "Oranžové kosmo delené pole",
  "block.minecraft.banner.diagonal_right.pink": "Ružové kosmo delené pole",
  "block.minecraft.banner.diagonal_right.purple": "Fialové kosmo delené pole",
  "block.minecraft.banner.diagonal_right.red": "Červené kosmo delené pole",
  "block.minecraft.banner.diagonal_right.white": "Biele kosmo delené pole",
  "block.minecraft.banner.diagonal_right.yellow": "Žlté kosmo delené pole",
  "block.minecraft.banner.diagonal_up_left.black": "Čierne kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.blue": "Modré kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.brown": "Hnedé kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tyrkysové kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.gray": "Sivé kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.green": "Zelené kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Svetlomodré kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Svetlosivé kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.lime": "Svetlozelené kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurové kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranžové kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.pink": "Ružové kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.purple": "Fialové kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.red": "Červené kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.white": "Biele kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žlté kosmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.black": "Čierne šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.blue": "Modré šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.brown": "Hnedé šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tyrkysové šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.gray": "Sivé šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.green": "Zelené šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Svetlomodré šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Svetlosivé šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.lime": "Svetlozelené šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurové šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranžové šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.pink": "Ružové šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.purple": "Fialové šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.red": "Červené šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.white": "Biele šikmo delené pole obrátené",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žlté šikmo delené pole obrátené",
  "block.minecraft.banner.flow.black": "Čierny tok",
  "block.minecraft.banner.flow.blue": "Modrý tok",
  "block.minecraft.banner.flow.brown": "Hnedý tok",
  "block.minecraft.banner.flow.cyan": "Tyrkysový tok",
  "block.minecraft.banner.flow.gray": "Sivý tok",
  "block.minecraft.banner.flow.green": "Zelený tok",
  "block.minecraft.banner.flow.light_blue": "Svetlomodrý tok",
  "block.minecraft.banner.flow.light_gray": "Svetlosivý tok",
  "block.minecraft.banner.flow.lime": "Svetlozelený tok",
  "block.minecraft.banner.flow.magenta": "Purpurový tok",
  "block.minecraft.banner.flow.orange": "Oranžový tok",
  "block.minecraft.banner.flow.pink": "Ružový tok",
  "block.minecraft.banner.flow.purple": "Fialový tok",
  "block.minecraft.banner.flow.red": "Červený tok",
  "block.minecraft.banner.flow.white": "Biely tok",
  "block.minecraft.banner.flow.yellow": "Žltý tok",
  "block.minecraft.banner.flower.black": "Čierny kvet",
  "block.minecraft.banner.flower.blue": "Modrý kvet",
  "block.minecraft.banner.flower.brown": "Hnedý kvet",
  "block.minecraft.banner.flower.cyan": "Tyrkysový kvet",
  "block.minecraft.banner.flower.gray": "Sivý kvet",
  "block.minecraft.banner.flower.green": "Zelený kvet",
  "block.minecraft.banner.flower.light_blue": "Svetlomodrý kvet",
  "block.minecraft.banner.flower.light_gray": "Svetlosivý kvet",
  "block.minecraft.banner.flower.lime": "Svetlozelený kvet",
  "block.minecraft.banner.flower.magenta": "Purpurový kvet",
  "block.minecraft.banner.flower.orange": "Oranžový kvet",
  "block.minecraft.banner.flower.pink": "Ružový kvet",
  "block.minecraft.banner.flower.purple": "Fialový kvet",
  "block.minecraft.banner.flower.red": "Červený kvet",
  "block.minecraft.banner.flower.white": "Biely kvet",
  "block.minecraft.banner.flower.yellow": "Žltý kvet",
  "block.minecraft.banner.globe.black": "Čierny glóbus",
  "block.minecraft.banner.globe.blue": "Modrý glóbus",
  "block.minecraft.banner.globe.brown": "Hnedý glóbus",
  "block.minecraft.banner.globe.cyan": "Tyrkysový glóbus",
  "block.minecraft.banner.globe.gray": "Sivý glóbus",
  "block.minecraft.banner.globe.green": "Zelený glóbus",
  "block.minecraft.banner.globe.light_blue": "Svetlomodrý glóbus",
  "block.minecraft.banner.globe.light_gray": "Svetlosivý glóbus",
  "block.minecraft.banner.globe.lime": "Svetlozelený glóbus",
  "block.minecraft.banner.globe.magenta": "Purpurový glóbus",
  "block.minecraft.banner.globe.orange": "Oranžový glóbus",
  "block.minecraft.banner.globe.pink": "Ružový glóbus",
  "block.minecraft.banner.globe.purple": "Fialový glóbus",
  "block.minecraft.banner.globe.red": "Červený glóbus",
  "block.minecraft.banner.globe.white": "Biely glóbus",
  "block.minecraft.banner.globe.yellow": "Žltý glóbus",
  "block.minecraft.banner.gradient.black": "Čierny prechod",
  "block.minecraft.banner.gradient.blue": "Modrý prechod",
  "block.minecraft.banner.gradient.brown": "Hnedý prechod",
  "block.minecraft.banner.gradient.cyan": "Tyrkysový prechod",
  "block.minecraft.banner.gradient.gray": "Sivý prechod",
  "block.minecraft.banner.gradient.green": "Zelený prechod",
  "block.minecraft.banner.gradient.light_blue": "Svetlomodrý prechod",
  "block.minecraft.banner.gradient.light_gray": "Svetlosivý prechod",
  "block.minecraft.banner.gradient.lime": "Svetlozelený prechod",
  "block.minecraft.banner.gradient.magenta": "Purpurový prechod",
  "block.minecraft.banner.gradient.orange": "Oranžový prechod",
  "block.minecraft.banner.gradient.pink": "Ružový prechod",
  "block.minecraft.banner.gradient.purple": "Fialový prechod",
  "block.minecraft.banner.gradient.red": "Červený prechod",
  "block.minecraft.banner.gradient.white": "Biely prechod",
  "block.minecraft.banner.gradient.yellow": "Žltý prechod",
  "block.minecraft.banner.gradient_up.black": "Čierny prechod obrátený",
  "block.minecraft.banner.gradient_up.blue": "Modrý prechod obrátený",
  "block.minecraft.banner.gradient_up.brown": "Hnedý prechod obrátený",
  "block.minecraft.banner.gradient_up.cyan": "Tyrkysový prechod obrátený",
  "block.minecraft.banner.gradient_up.gray": "Sivý prechod obrátený",
  "block.minecraft.banner.gradient_up.green": "Zelený prechod obrátený",
  "block.minecraft.banner.gradient_up.light_blue": "Svetlomodrý prechod obrátený",
  "block.minecraft.banner.gradient_up.light_gray": "Svetlosivý prechod obrátený",
  "block.minecraft.banner.gradient_up.lime": "Svetlozelený prechod obrátený",
  "block.minecraft.banner.gradient_up.magenta": "Purpurový prechod obrátený",
  "block.minecraft.banner.gradient_up.orange": "Oranžový prechod obrátený",
  "block.minecraft.banner.gradient_up.pink": "Ružový prechod obrátený",
  "block.minecraft.banner.gradient_up.purple": "Fialový prechod obrátený",
  "block.minecraft.banner.gradient_up.red": "Červený prechod obrátený",
  "block.minecraft.banner.gradient_up.white": "Biely prechod obrátený",
  "block.minecraft.banner.gradient_up.yellow": "Žltý prechod obrátený",
  "block.minecraft.banner.guster.black": "Čierny fujak",
  "block.minecraft.banner.guster.blue": "Modrý fujak",
  "block.minecraft.banner.guster.brown": "Hnedý fujak",
  "block.minecraft.banner.guster.cyan": "Tyrkysový fujak",
  "block.minecraft.banner.guster.gray": "Sivý fujak",
  "block.minecraft.banner.guster.green": "Zelený fujak",
  "block.minecraft.banner.guster.light_blue": "Svetlomodrý fujak",
  "block.minecraft.banner.guster.light_gray": "Svetlosivý fujak",
  "block.minecraft.banner.guster.lime": "Svetlozelený fujak",
  "block.minecraft.banner.guster.magenta": "Purpurový fujak",
  "block.minecraft.banner.guster.orange": "Oranžový fujak",
  "block.minecraft.banner.guster.pink": "Ružový fujak",
  "block.minecraft.banner.guster.purple": "Fialový fujak",
  "block.minecraft.banner.guster.red": "Červený fujak",
  "block.minecraft.banner.guster.white": "Biely fujak",
  "block.minecraft.banner.guster.yellow": "Žltý fujak",
  "block.minecraft.banner.half_horizontal.black": "Čierne vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.blue": "Modré vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.brown": "Hnedé vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.cyan": "Tyrkysové vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.gray": "Sivé vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.green": "Zelené vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.light_blue": "Svetlomodré vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.light_gray": "Svetlosivé vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.lime": "Svetlozelené vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurové vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.orange": "Oranžové vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.pink": "Ružové vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.purple": "Fialové vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.red": "Červené vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.white": "Bielé vodorovne delené pole",
  "block.minecraft.banner.half_horizontal.yellow": "Žlté vodorovne delené pole",
  "block.minecraft.banner.half_horizontal_bottom.black": "Čierne vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Modré vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Hnedé vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Tyrkysové vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Sivé vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zelené vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Svetlomodré vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Svetlosivé vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Svetlozelené vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurové vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranžové vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ružové vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Fialové vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.red": "Červené vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.white": "Biele vodorovne delené pole obrátené",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žlté vodorovne delené pole obrátené",
  "block.minecraft.banner.half_vertical.black": "Čierne zvislo delené pole",
  "block.minecraft.banner.half_vertical.blue": "Modré zvislo delené pole",
  "block.minecraft.banner.half_vertical.brown": "Hnedé zvislo delené pole",
  "block.minecraft.banner.half_vertical.cyan": "Tyrkysové zvislo delené pole",
  "block.minecraft.banner.half_vertical.gray": "Sivé zvislo delené pole",
  "block.minecraft.banner.half_vertical.green": "Zelené zvislo delené pole",
  "block.minecraft.banner.half_vertical.light_blue": "Svetlomodré zvislo delené pole",
  "block.minecraft.banner.half_vertical.light_gray": "Svetlosivé zvislo delené pole",
  "block.minecraft.banner.half_vertical.lime": "Svetlozelené zvislo delené pole",
  "block.minecraft.banner.half_vertical.magenta": "Purpurové zvislo delené pole",
  "block.minecraft.banner.half_vertical.orange": "Oranžové zvislo delené pole",
  "block.minecraft.banner.half_vertical.pink": "Ružové zvislo delené pole",
  "block.minecraft.banner.half_vertical.purple": "Fialové zvislo delené pole",
  "block.minecraft.banner.half_vertical.red": "Červené zvislo delené pole",
  "block.minecraft.banner.half_vertical.white": "Biele zvislo delené pole",
  "block.minecraft.banner.half_vertical.yellow": "Žlté zvislo delené pole",
  "block.minecraft.banner.half_vertical_right.black": "Čierne zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.blue": "Modré zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.brown": "Hnedé zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.cyan": "Tyrkysové zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.gray": "Sivé zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.green": "Zelené zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.light_blue": "Svetlomodré zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.light_gray": "Svetlosivé zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.lime": "Svetlozelené zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurové zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.orange": "Oranžové zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.pink": "Ružové zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.purple": "Fialové zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.red": "Červené zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.white": "Biele zvislo delené pole obrátené",
  "block.minecraft.banner.half_vertical_right.yellow": "Žlté zvislo delené pole obrátené",
  "block.minecraft.banner.mojang.black": "Čierna vecička",
  "block.minecraft.banner.mojang.blue": "Modrá vecička",
  "block.minecraft.banner.mojang.brown": "Hnedá vecička",
  "block.minecraft.banner.mojang.cyan": "Tyrkysová vecička",
  "block.minecraft.banner.mojang.gray": "Sivá vecička",
  "block.minecraft.banner.mojang.green": "Zelená vecička",
  "block.minecraft.banner.mojang.light_blue": "Svetlomodrá vecička",
  "block.minecraft.banner.mojang.light_gray": "Svetlosivá vecička",
  "block.minecraft.banner.mojang.lime": "Svetlozelená vecička",
  "block.minecraft.banner.mojang.magenta": "Purpurová vecička",
  "block.minecraft.banner.mojang.orange": "Oranžová vecička",
  "block.minecraft.banner.mojang.pink": "Ružová vecička",
  "block.minecraft.banner.mojang.purple": "Fialová vecička",
  "block.minecraft.banner.mojang.red": "Červená vecička",
  "block.minecraft.banner.mojang.white": "Biela vecička",
  "block.minecraft.banner.mojang.yellow": "Žltá vecička",
  "block.minecraft.banner.piglin.black": "Čierny rypák",
  "block.minecraft.banner.piglin.blue": "Modrý rypák",
  "block.minecraft.banner.piglin.brown": "Hnedý rypák",
  "block.minecraft.banner.piglin.cyan": "Tyrkysový rypák",
  "block.minecraft.banner.piglin.gray": "Sivý rypák",
  "block.minecraft.banner.piglin.green": "Zelený rypák",
  "block.minecraft.banner.piglin.light_blue": "Svetlomodrý rypák",
  "block.minecraft.banner.piglin.light_gray": "Svetlosivý rypák",
  "block.minecraft.banner.piglin.lime": "Svetlozelený rypák",
  "block.minecraft.banner.piglin.magenta": "Purpurový rypák",
  "block.minecraft.banner.piglin.orange": "Oranžový rypák",
  "block.minecraft.banner.piglin.pink": "Ružový rypák",
  "block.minecraft.banner.piglin.purple": "Fialový rypák",
  "block.minecraft.banner.piglin.red": "Červený rypák",
  "block.minecraft.banner.piglin.white": "Biely rypák",
  "block.minecraft.banner.piglin.yellow": "Žltý rypák",
  "block.minecraft.banner.rhombus.black": "Čierna ruta",
  "block.minecraft.banner.rhombus.blue": "Modrá ruta",
  "block.minecraft.banner.rhombus.brown": "Hnedá ruta",
  "block.minecraft.banner.rhombus.cyan": "Tyrkysová ruta",
  "block.minecraft.banner.rhombus.gray": "Sivá ruta",
  "block.minecraft.banner.rhombus.green": "Zelená ruta",
  "block.minecraft.banner.rhombus.light_blue": "Svetlomodrá ruta",
  "block.minecraft.banner.rhombus.light_gray": "Svetlosivá ruta",
  "block.minecraft.banner.rhombus.lime": "Zelená ruta",
  "block.minecraft.banner.rhombus.magenta": "Purpurová ruta",
  "block.minecraft.banner.rhombus.orange": "Oranžová ruta",
  "block.minecraft.banner.rhombus.pink": "Ružová ruta",
  "block.minecraft.banner.rhombus.purple": "Fialová ruta",
  "block.minecraft.banner.rhombus.red": "Červená ruta",
  "block.minecraft.banner.rhombus.white": "Biela ruta",
  "block.minecraft.banner.rhombus.yellow": "Žltá ruta",
  "block.minecraft.banner.skull.black": "Čierna lebka",
  "block.minecraft.banner.skull.blue": "Modrá lebka",
  "block.minecraft.banner.skull.brown": "Hnedá lebka",
  "block.minecraft.banner.skull.cyan": "Tyrkysová lebka",
  "block.minecraft.banner.skull.gray": "Sivá lebka",
  "block.minecraft.banner.skull.green": "Zelená lebka",
  "block.minecraft.banner.skull.light_blue": "Svetlomodrá lebka",
  "block.minecraft.banner.skull.light_gray": "Svetlosivá lebka",
  "block.minecraft.banner.skull.lime": "Svetlozelená lebka",
  "block.minecraft.banner.skull.magenta": "Purpurová lebka",
  "block.minecraft.banner.skull.orange": "Oranžová lebka",
  "block.minecraft.banner.skull.pink": "Ružová lebka",
  "block.minecraft.banner.skull.purple": "Fialová lebka",
  "block.minecraft.banner.skull.red": "Červená lebka",
  "block.minecraft.banner.skull.white": "Biela lebka",
  "block.minecraft.banner.skull.yellow": "Žltá lebka",
  "block.minecraft.banner.small_stripes.black": "Čierne pruhy",
  "block.minecraft.banner.small_stripes.blue": "Modré pruhy",
  "block.minecraft.banner.small_stripes.brown": "Hnedé pruhy",
  "block.minecraft.banner.small_stripes.cyan": "Tyrkysové pruhy",
  "block.minecraft.banner.small_stripes.gray": "Sivé pruhy",
  "block.minecraft.banner.small_stripes.green": "Zelené pruhy",
  "block.minecraft.banner.small_stripes.light_blue": "Svetlomodré pruhy",
  "block.minecraft.banner.small_stripes.light_gray": "Svetlosivé pruhy",
  "block.minecraft.banner.small_stripes.lime": "Svetlozelené pruhy",
  "block.minecraft.banner.small_stripes.magenta": "Purpurové pruhy",
  "block.minecraft.banner.small_stripes.orange": "Oranžový pruhy",
  "block.minecraft.banner.small_stripes.pink": "Ružové pruhy",
  "block.minecraft.banner.small_stripes.purple": "Fialové pruhy",
  "block.minecraft.banner.small_stripes.red": "Červené pruhy",
  "block.minecraft.banner.small_stripes.white": "Biele pruhy",
  "block.minecraft.banner.small_stripes.yellow": "Žlté pruhy",
  "block.minecraft.banner.square_bottom_left.black": "Čierna spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.blue": "Modrá spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.brown": "Hnedá  spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.cyan": "Tyrkysová spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.gray": "Sivá spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.green": "Zelená spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.light_blue": "Svetlomodrá spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.light_gray": "Svetlosivá spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.lime": "Svetlozelená spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurová spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.orange": "Oranžová spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.pink": "Ružová spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.purple": "Fialová spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.red": "Červená spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.white": "Biela spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_left.yellow": "Žltá spodná ľavá štvrtina",
  "block.minecraft.banner.square_bottom_right.black": "Čierna spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.blue": "Modrá spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.brown": "Hnedá spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.cyan": "Tyrkysová spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.gray": "Sivá spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.green": "Zelená spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.light_blue": "Svetlomodrá spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.light_gray": "Svetlosivá spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.lime": "Svetlozelená spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurová spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.orange": "Oranžová spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.pink": "Ružová spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.purple": "Fialová spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.red": "Červená spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.white": "Biela spodná pravá štvrtina",
  "block.minecraft.banner.square_bottom_right.yellow": "Žltá spodná pravá štvrtina",
  "block.minecraft.banner.square_top_left.black": "Čierna horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.blue": "Modrá horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.brown": "Hnedá horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.cyan": "Tyrkysová horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.gray": "Sivá horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.green": "Zelená horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.light_blue": "Svetlomodrá horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.light_gray": "Svetlosivá horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.lime": "Svetlozelená horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.magenta": "Purpurová horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.orange": "Oranžová horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.pink": "Ružová horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.purple": "Fialová horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.red": "Červená horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.white": "Biela horná ľavá štvrtina",
  "block.minecraft.banner.square_top_left.yellow": "Žltá horná ľavá štvrtina",
  "block.minecraft.banner.square_top_right.black": "Čierna horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.blue": "Modrá horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.brown": "Hnedá horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.cyan": "Tyrkysová horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.gray": "Sivá horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.green": "Zelená horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.light_blue": "Svetlomodrá horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.light_gray": "Svetlosivá horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.lime": "Svetlozelená horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.magenta": "Purpurová horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.orange": "Oranžová horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.pink": "Ružová horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.purple": "Fialová horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.red": "Červená horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.white": "Biela horná pravá štvrtina",
  "block.minecraft.banner.square_top_right.yellow": "Žltá horná pravá štvrtina",
  "block.minecraft.banner.straight_cross.black": "Čierny kríž",
  "block.minecraft.banner.straight_cross.blue": "Modrý kríž",
  "block.minecraft.banner.straight_cross.brown": "Hnedý kríž",
  "block.minecraft.banner.straight_cross.cyan": "Tyrkysový kríž",
  "block.minecraft.banner.straight_cross.gray": "Sivý kríž",
  "block.minecraft.banner.straight_cross.green": "Zelený kríž",
  "block.minecraft.banner.straight_cross.light_blue": "Svetlomodrý kríž",
  "block.minecraft.banner.straight_cross.light_gray": "Svetlosivý kríž",
  "block.minecraft.banner.straight_cross.lime": "Svetlozelený kríž",
  "block.minecraft.banner.straight_cross.magenta": "Purpurový kríž",
  "block.minecraft.banner.straight_cross.orange": "Oranžový kríž",
  "block.minecraft.banner.straight_cross.pink": "Ružový kríž",
  "block.minecraft.banner.straight_cross.purple": "Fialový kríž",
  "block.minecraft.banner.straight_cross.red": "Červený kríž",
  "block.minecraft.banner.straight_cross.white": "Biely kríž",
  "block.minecraft.banner.straight_cross.yellow": "Žltý kríž",
  "block.minecraft.banner.stripe_bottom.black": "Čierna päta",
  "block.minecraft.banner.stripe_bottom.blue": "Modrá päta",
  "block.minecraft.banner.stripe_bottom.brown": "Hnedá päta",
  "block.minecraft.banner.stripe_bottom.cyan": "Tyrkysová päta",
  "block.minecraft.banner.stripe_bottom.gray": "Sivá päta",
  "block.minecraft.banner.stripe_bottom.green": "Zelená päta",
  "block.minecraft.banner.stripe_bottom.light_blue": "Svetlomodrá päta",
  "block.minecraft.banner.stripe_bottom.light_gray": "Svetlosivá päta",
  "block.minecraft.banner.stripe_bottom.lime": "Svetlozelená päta",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurová päta",
  "block.minecraft.banner.stripe_bottom.orange": "Oranžová päta",
  "block.minecraft.banner.stripe_bottom.pink": "Ružová päta",
  "block.minecraft.banner.stripe_bottom.purple": "Fialová päta",
  "block.minecraft.banner.stripe_bottom.red": "Červená päta",
  "block.minecraft.banner.stripe_bottom.white": "Biela päta",
  "block.minecraft.banner.stripe_bottom.yellow": "Žltá päta",
  "block.minecraft.banner.stripe_center.black": "Čierny kôl",
  "block.minecraft.banner.stripe_center.blue": "Modrý kôl",
  "block.minecraft.banner.stripe_center.brown": "Hnedý kôl",
  "block.minecraft.banner.stripe_center.cyan": "Tyrkysový kôl",
  "block.minecraft.banner.stripe_center.gray": "Sivý kôl",
  "block.minecraft.banner.stripe_center.green": "Zelený kôl",
  "block.minecraft.banner.stripe_center.light_blue": "Svetlomodrý kôl",
  "block.minecraft.banner.stripe_center.light_gray": "Svetlosivý kôl",
  "block.minecraft.banner.stripe_center.lime": "Svetlozelený kôl",
  "block.minecraft.banner.stripe_center.magenta": "Purpurový kôl",
  "block.minecraft.banner.stripe_center.orange": "Oranžový kôl",
  "block.minecraft.banner.stripe_center.pink": "Ružový kôl",
  "block.minecraft.banner.stripe_center.purple": "Fialový kôl",
  "block.minecraft.banner.stripe_center.red": "Červený kôl",
  "block.minecraft.banner.stripe_center.white": "Biely kôl",
  "block.minecraft.banner.stripe_center.yellow": "Žltý kôl",
  "block.minecraft.banner.stripe_downleft.black": "Čierne šikmé brvno",
  "block.minecraft.banner.stripe_downleft.blue": "Modré šikmé brvno",
  "block.minecraft.banner.stripe_downleft.brown": "Hnedé šikmé brvno",
  "block.minecraft.banner.stripe_downleft.cyan": "Tyrkysové šikmé brvno",
  "block.minecraft.banner.stripe_downleft.gray": "Sivé šikmé brvno",
  "block.minecraft.banner.stripe_downleft.green": "Zelené šikmé brvno",
  "block.minecraft.banner.stripe_downleft.light_blue": "Svetlomodré šikmé brvno",
  "block.minecraft.banner.stripe_downleft.light_gray": "Svetlosivé šikmé brvno",
  "block.minecraft.banner.stripe_downleft.lime": "Svetlozelené šikmé brvno",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurové šikmé brvno",
  "block.minecraft.banner.stripe_downleft.orange": "Oranžové šikmé brvno",
  "block.minecraft.banner.stripe_downleft.pink": "Ružové šikmé brvno",
  "block.minecraft.banner.stripe_downleft.purple": "Fialové šikmé brvno",
  "block.minecraft.banner.stripe_downleft.red": "Červené šikmé brvno",
  "block.minecraft.banner.stripe_downleft.white": "Biele šikmé brvno",
  "block.minecraft.banner.stripe_downleft.yellow": "Žlté šikmé brvno",
  "block.minecraft.banner.stripe_downright.black": "Čierne kosmé brvno",
  "block.minecraft.banner.stripe_downright.blue": "Modré kosmé brvno",
  "block.minecraft.banner.stripe_downright.brown": "Hnedé kosmé brvno",
  "block.minecraft.banner.stripe_downright.cyan": "Tyrkysové kosmé brvno",
  "block.minecraft.banner.stripe_downright.gray": "Sivé kosmé brvno",
  "block.minecraft.banner.stripe_downright.green": "Zelené kosmé brvno",
  "block.minecraft.banner.stripe_downright.light_blue": "Svetlomodré kosmé brvno",
  "block.minecraft.banner.stripe_downright.light_gray": "Svetlosivé kosmé brvno",
  "block.minecraft.banner.stripe_downright.lime": "Svetlozelené kosmé brvno",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurové kosmé brvno",
  "block.minecraft.banner.stripe_downright.orange": "Oranžové kosmé brvno",
  "block.minecraft.banner.stripe_downright.pink": "Ružové kosmé brvno",
  "block.minecraft.banner.stripe_downright.purple": "Fialové kosmé brvno",
  "block.minecraft.banner.stripe_downright.red": "Červené kosmé brvno",
  "block.minecraft.banner.stripe_downright.white": "Bielé kosmé brvno",
  "block.minecraft.banner.stripe_downright.yellow": "Žlté kosmé brvno",
  "block.minecraft.banner.stripe_left.black": "Čierny ľavý pruh",
  "block.minecraft.banner.stripe_left.blue": "Modrý ľavý pruh",
  "block.minecraft.banner.stripe_left.brown": "Hnedý ľavý pruh",
  "block.minecraft.banner.stripe_left.cyan": "Tyrkysový ľavý pruh",
  "block.minecraft.banner.stripe_left.gray": "Sivý ľavý pruh",
  "block.minecraft.banner.stripe_left.green": "Zelený ľavý pruh",
  "block.minecraft.banner.stripe_left.light_blue": "Svetlomodrý ľavý pruh",
  "block.minecraft.banner.stripe_left.light_gray": "Svetlosivý ľavý pruh",
  "block.minecraft.banner.stripe_left.lime": "Svetlozelený ľavý pruh",
  "block.minecraft.banner.stripe_left.magenta": "Purpurový ľavý pruh",
  "block.minecraft.banner.stripe_left.orange": "Oranžový ľavý pruh",
  "block.minecraft.banner.stripe_left.pink": "Ružový ľavý pruh",
  "block.minecraft.banner.stripe_left.purple": "Fialový ľavý pruh",
  "block.minecraft.banner.stripe_left.red": "Červený ľavý pruh",
  "block.minecraft.banner.stripe_left.white": "Biely ľavý pruh",
  "block.minecraft.banner.stripe_left.yellow": "Žltý ľavý pruh",
  "block.minecraft.banner.stripe_middle.black": "Čierne brvno",
  "block.minecraft.banner.stripe_middle.blue": "Modré brvno",
  "block.minecraft.banner.stripe_middle.brown": "Hnedé brvno",
  "block.minecraft.banner.stripe_middle.cyan": "Tyrkysové brvno",
  "block.minecraft.banner.stripe_middle.gray": "Sivé brvno",
  "block.minecraft.banner.stripe_middle.green": "Zelené brvno",
  "block.minecraft.banner.stripe_middle.light_blue": "Svetlomodré brvno",
  "block.minecraft.banner.stripe_middle.light_gray": "Svetlosivé brvno",
  "block.minecraft.banner.stripe_middle.lime": "Svetlozelené brvno",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurové brvno",
  "block.minecraft.banner.stripe_middle.orange": "Oranžové brvno",
  "block.minecraft.banner.stripe_middle.pink": "Ružové brvno",
  "block.minecraft.banner.stripe_middle.purple": "Fialové brvno",
  "block.minecraft.banner.stripe_middle.red": "Červené brvno",
  "block.minecraft.banner.stripe_middle.white": "Biele brvno",
  "block.minecraft.banner.stripe_middle.yellow": "Žlté brvno",
  "block.minecraft.banner.stripe_right.black": "Čierny pravý pruh",
  "block.minecraft.banner.stripe_right.blue": "Modrý pravý pruh",
  "block.minecraft.banner.stripe_right.brown": "Hnedý pravý pruh",
  "block.minecraft.banner.stripe_right.cyan": "Tyrkysový pravý pruh",
  "block.minecraft.banner.stripe_right.gray": "Sivý pravý pruh",
  "block.minecraft.banner.stripe_right.green": "Zelený pravý pruh",
  "block.minecraft.banner.stripe_right.light_blue": "Svetlomodrý pravý pruh",
  "block.minecraft.banner.stripe_right.light_gray": "Svetlosivý pravý pruh",
  "block.minecraft.banner.stripe_right.lime": "Svetlozelený pravý pruh",
  "block.minecraft.banner.stripe_right.magenta": "Purpurový pravý pruh",
  "block.minecraft.banner.stripe_right.orange": "Oranžový pravý pruh",
  "block.minecraft.banner.stripe_right.pink": "Ružový pravý pruh",
  "block.minecraft.banner.stripe_right.purple": "Fialový pravý pruh",
  "block.minecraft.banner.stripe_right.red": "Červený pravý pruh",
  "block.minecraft.banner.stripe_right.white": "Biely pravý pruh",
  "block.minecraft.banner.stripe_right.yellow": "Žltý pravý pruh",
  "block.minecraft.banner.stripe_top.black": "Čierna hlava",
  "block.minecraft.banner.stripe_top.blue": "Modrá hlava",
  "block.minecraft.banner.stripe_top.brown": "Hnedá hlava",
  "block.minecraft.banner.stripe_top.cyan": "Tyrkysová hlava",
  "block.minecraft.banner.stripe_top.gray": "Sivá hlava",
  "block.minecraft.banner.stripe_top.green": "Zelená hlava",
  "block.minecraft.banner.stripe_top.light_blue": "Svetlomodrá hlava",
  "block.minecraft.banner.stripe_top.light_gray": "Svetlosivá hlava",
  "block.minecraft.banner.stripe_top.lime": "Svetlozelená hlava",
  "block.minecraft.banner.stripe_top.magenta": "Purpurová hlava",
  "block.minecraft.banner.stripe_top.orange": "Oranžová hlava",
  "block.minecraft.banner.stripe_top.pink": "Ružová hlava",
  "block.minecraft.banner.stripe_top.purple": "Fialová hlava",
  "block.minecraft.banner.stripe_top.red": "Červená hlava",
  "block.minecraft.banner.stripe_top.white": "Biela hlava",
  "block.minecraft.banner.stripe_top.yellow": "Žltá hlava",
  "block.minecraft.banner.triangle_bottom.black": "Čierna krokva",
  "block.minecraft.banner.triangle_bottom.blue": "Modrá krokva",
  "block.minecraft.banner.triangle_bottom.brown": "Hnedá krokva",
  "block.minecraft.banner.triangle_bottom.cyan": "Tyrkysová krokva",
  "block.minecraft.banner.triangle_bottom.gray": "Sivá krokva",
  "block.minecraft.banner.triangle_bottom.green": "Zelená krokva",
  "block.minecraft.banner.triangle_bottom.light_blue": "Svetlomodrá krokva",
  "block.minecraft.banner.triangle_bottom.light_gray": "Svetlosivá krokva",
  "block.minecraft.banner.triangle_bottom.lime": "Svetlozelená krokva",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurová krokva",
  "block.minecraft.banner.triangle_bottom.orange": "Oranžová krokva",
  "block.minecraft.banner.triangle_bottom.pink": "Ružová krokva",
  "block.minecraft.banner.triangle_bottom.purple": "Fialová krokva",
  "block.minecraft.banner.triangle_bottom.red": "Červená krokva",
  "block.minecraft.banner.triangle_bottom.white": "Biela krokva",
  "block.minecraft.banner.triangle_bottom.yellow": "Žltá krokva",
  "block.minecraft.banner.triangle_top.black": "Čierny klin",
  "block.minecraft.banner.triangle_top.blue": "Modrý klin",
  "block.minecraft.banner.triangle_top.brown": "Hnedý klin",
  "block.minecraft.banner.triangle_top.cyan": "Tyrkysový klin",
  "block.minecraft.banner.triangle_top.gray": "Sivý klin",
  "block.minecraft.banner.triangle_top.green": "Zelený klin",
  "block.minecraft.banner.triangle_top.light_blue": "Svetlomodrý klin",
  "block.minecraft.banner.triangle_top.light_gray": "Svetlosivý klin",
  "block.minecraft.banner.triangle_top.lime": "Svetlozelený klin",
  "block.minecraft.banner.triangle_top.magenta": "Purpurový klin",
  "block.minecraft.banner.triangle_top.orange": "Oranžový klin",
  "block.minecraft.banner.triangle_top.pink": "Ružový klin",
  "block.minecraft.banner.triangle_top.purple": "Fialový klin",
  "block.minecraft.banner.triangle_top.red": "Červený klin",
  "block.minecraft.banner.triangle_top.white": "Biely klin",
  "block.minecraft.banner.triangle_top.yellow": "Žltý klin",
  "block.minecraft.banner.triangles_bottom.black": "Čierna zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.blue": "Modrá zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.brown": "Hnedá zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.cyan": "Tyrkysová zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.gray": "Sivá zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.green": "Zelená zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.light_blue": "Svetlomodrá zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.light_gray": "Svetlosivá zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.lime": "Svetlozelená zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurová zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.orange": "Oranžová zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.pink": "Ružová zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.purple": "Fialová zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.red": "Červená zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.white": "Biela zúbkovaná päta",
  "block.minecraft.banner.triangles_bottom.yellow": "Žltá zúbkovaná päta",
  "block.minecraft.banner.triangles_top.black": "Čierna zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.blue": "Modrá zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.brown": "Hnedá zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.cyan": "Tyrkysová zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.gray": "Sivá zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.green": "Zelená zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.light_blue": "Svetlomodrá zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.light_gray": "Svetlosivá zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.lime": "Svetlozelená zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.magenta": "Purpurová zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.orange": "Oranžová zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.pink": "Ružová zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.purple": "Fialová zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.red": "Červená zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.white": "Biela zúbkovaná hlava",
  "block.minecraft.banner.triangles_top.yellow": "Žltá zúbkovaná hlava",
  "block.minecraft.barrel": "Sud",
  "block.minecraft.barrier": "Bariéra",
  "block.minecraft.basalt": "Čadič",
  "block.minecraft.beacon": "Maják",
  "block.minecraft.beacon.primary": "Primárna sila",
  "block.minecraft.beacon.secondary": "Sekundárna sila",
  "block.minecraft.bed.no_sleep": "Spať môžeš iba v noci alebo počas búrok",
  "block.minecraft.bed.not_safe": "Teraz nemôžeš odpočívať, v blízkosti sa nachádzajú príšery",
  "block.minecraft.bed.obstructed": "Táto posteľ je zablokovaná",
  "block.minecraft.bed.occupied": "Táto posteľ je obsadená",
  "block.minecraft.bed.too_far_away": "Teraz nemôžeš odpočívať, posteľ je príliš ďaleko",
  "block.minecraft.bedrock": "Podložie",
  "block.minecraft.bee_nest": "Včelie hniezdo",
  "block.minecraft.beehive": "Včelí úľ",
  "block.minecraft.beetroots": "Repa",
  "block.minecraft.bell": "Zvon",
  "block.minecraft.big_dripleaf": "Veľký kvapkavec",
  "block.minecraft.big_dripleaf_stem": "Stonka veľkého kvapkavca",
  "block.minecraft.birch_button": "Brezové tlačidlo",
  "block.minecraft.birch_door": "Brezové dvere",
  "block.minecraft.birch_fence": "Brezový plot",
  "block.minecraft.birch_fence_gate": "Brezová bránka",
  "block.minecraft.birch_hanging_sign": "Brezová závesná ceduľa",
  "block.minecraft.birch_leaves": "Brezové listy",
  "block.minecraft.birch_log": "Brezový kmeň",
  "block.minecraft.birch_planks": "Brezové dosky",
  "block.minecraft.birch_pressure_plate": "Brezová nášľapná doska",
  "block.minecraft.birch_sapling": "Brezová sadenica",
  "block.minecraft.birch_shelf": "Brezová polička",
  "block.minecraft.birch_sign": "Brezová ceduľa",
  "block.minecraft.birch_slab": "Brezový stupienok",
  "block.minecraft.birch_stairs": "Brezové schody",
  "block.minecraft.birch_trapdoor": "Brezový poklop",
  "block.minecraft.birch_wall_hanging_sign": "Nástenná brezová závesná ceduľa",
  "block.minecraft.birch_wall_sign": "Nástenná brezová ceduľa",
  "block.minecraft.birch_wood": "Brezové drevo",
  "block.minecraft.black_banner": "Čierna zástava",
  "block.minecraft.black_bed": "Čierna posteľ",
  "block.minecraft.black_candle": "Čierna sviečka",
  "block.minecraft.black_candle_cake": "Torta s čiernou sviečkou",
  "block.minecraft.black_carpet": "Čierny koberec",
  "block.minecraft.black_concrete": "Čierny betón",
  "block.minecraft.black_concrete_powder": "Čierny cement",
  "block.minecraft.black_glazed_terracotta": "Čierna glazovaná terakota",
  "block.minecraft.black_shulker_box": "Čierna Shulker schránka",
  "block.minecraft.black_stained_glass": "Čierne sklo",
  "block.minecraft.black_stained_glass_pane": "Čierny sklenený panel",
  "block.minecraft.black_terracotta": "Čierna terakota",
  "block.minecraft.black_wool": "Čierna vlna",
  "block.minecraft.blackstone": "Čierny kameň",
  "block.minecraft.blackstone_slab": "Stupienok z čierneho kameňa",
  "block.minecraft.blackstone_stairs": "Schody z čierneho kameňa",
  "block.minecraft.blackstone_wall": "Múr z čierneho kameňa",
  "block.minecraft.blast_furnace": "Tavná pec",
  "block.minecraft.blue_banner": "Modrá zástava",
  "block.minecraft.blue_bed": "Modrá posteľ",
  "block.minecraft.blue_candle": "Modrá sviečka",
  "block.minecraft.blue_candle_cake": "Torta s modrou sviečkou",
  "block.minecraft.blue_carpet": "Modrý koberec",
  "block.minecraft.blue_concrete": "Modrý betón",
  "block.minecraft.blue_concrete_powder": "Modrý cement",
  "block.minecraft.blue_glazed_terracotta": "Modrá glazovaná terakota",
  "block.minecraft.blue_ice": "Modrý ľad",
  "block.minecraft.blue_orchid": "Modrá orchidea",
  "block.minecraft.blue_shulker_box": "Modrá Shulker schránka",
  "block.minecraft.blue_stained_glass": "Modré sklo",
  "block.minecraft.blue_stained_glass_pane": "Modrý sklenený panel",
  "block.minecraft.blue_terracotta": "Modrá terakota",
  "block.minecraft.blue_wool": "Modrá vlna",
  "block.minecraft.bone_block": "Kocka kostí",
  "block.minecraft.bookshelf": "Knižnica",
  "block.minecraft.brain_coral": "Mozgovitý koral",
  "block.minecraft.brain_coral_block": "Kocka mozgovitého koralu",
  "block.minecraft.brain_coral_fan": "Vejár mozgovitého koralu",
  "block.minecraft.brain_coral_wall_fan": "Nástenný vejár mozgovitého koralu",
  "block.minecraft.brewing_stand": "Varný stojan",
  "block.minecraft.brick_slab": "Tehlový stupienok",
  "block.minecraft.brick_stairs": "Tehlové schody",
  "block.minecraft.brick_wall": "Tehlový múr",
  "block.minecraft.bricks": "Tehly",
  "block.minecraft.brown_banner": "Hnedá zástava",
  "block.minecraft.brown_bed": "Hnedá posteľ",
  "block.minecraft.brown_candle": "Hnedá sviečka",
  "block.minecraft.brown_candle_cake": "Torta s hnedou sviečkou",
  "block.minecraft.brown_carpet": "Hnedý koberec",
  "block.minecraft.brown_concrete": "Hnedý betón",
  "block.minecraft.brown_concrete_powder": "Hnedý cement",
  "block.minecraft.brown_glazed_terracotta": "Hnedá glazovaná terakota",
  "block.minecraft.brown_mushroom": "Hnedý hríb",
  "block.minecraft.brown_mushroom_block": "Hríbová kocka",
  "block.minecraft.brown_shulker_box": "Hnedá Shulker schránka",
  "block.minecraft.brown_stained_glass": "Hnedé sklo",
  "block.minecraft.brown_stained_glass_pane": "Hnedý sklenený panel",
  "block.minecraft.brown_terracotta": "Hnedá terakota",
  "block.minecraft.brown_wool": "Hnedá vlna",
  "block.minecraft.bubble_column": "Bublinkový stĺp",
  "block.minecraft.bubble_coral": "Bobuľovitý koral",
  "block.minecraft.bubble_coral_block": "Kocka bobuľovitého koralu",
  "block.minecraft.bubble_coral_fan": "Vejár bobuľovitého koralu",
  "block.minecraft.bubble_coral_wall_fan": "Nástenný vejár bobuľovitého koralu",
  "block.minecraft.budding_amethyst": "Pučiaci ametyst",
  "block.minecraft.bush": "Krík",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusový kvet",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrovaný sculk snímač",
  "block.minecraft.campfire": "Táborák",
  "block.minecraft.candle": "Sviečka",
  "block.minecraft.candle_cake": "Torta so sviečkou",
  "block.minecraft.carrots": "Mrkvy",
  "block.minecraft.cartography_table": "Kartografický stôl",
  "block.minecraft.carved_pumpkin": "Vyrezaná tekvica",
  "block.minecraft.cauldron": "Kotlík",
  "block.minecraft.cave_air": "Vzduch jaskyne",
  "block.minecraft.cave_vines": "Jaskynné liany",
  "block.minecraft.cave_vines_plant": "Stonka jaskynných lián",
  "block.minecraft.chain": "Reťaz",
  "block.minecraft.chain_command_block": "Reťazová príkazová kocka",
  "block.minecraft.cherry_button": "Čerešňové tlačidlo",
  "block.minecraft.cherry_door": "Čerešňové dvere",
  "block.minecraft.cherry_fence": "Čerešňový plot",
  "block.minecraft.cherry_fence_gate": "Čerešňová bránka",
  "block.minecraft.cherry_hanging_sign": "Čerešňová závesná ceduľa",
  "block.minecraft.cherry_leaves": "Čerešňové listy",
  "block.minecraft.cherry_log": "Čerešňový kmeň",
  "block.minecraft.cherry_planks": "Čerešňové dosky",
  "block.minecraft.cherry_pressure_plate": "Čerešňová nášľapná doska",
  "block.minecraft.cherry_sapling": "Čerešňová sadenica",
  "block.minecraft.cherry_shelf": "Čerešňová polička",
  "block.minecraft.cherry_sign": "Čerešňová ceduľa",
  "block.minecraft.cherry_slab": "Čerešňový stupienok",
  "block.minecraft.cherry_stairs": "Čerešňové schody",
  "block.minecraft.cherry_trapdoor": "Čerešňový poklop",
  "block.minecraft.cherry_wall_hanging_sign": "Nástenná čerešňová závesná ceduľa",
  "block.minecraft.cherry_wall_sign": "Nástenná čerešňová ceduľa",
  "block.minecraft.cherry_wood": "Čerešňové drevo",
  "block.minecraft.chest": "Truhlica",
  "block.minecraft.chipped_anvil": "Poškriabaná nákova",
  "block.minecraft.chiseled_bookshelf": "Vyrezávaná knižnica",
  "block.minecraft.chiseled_copper": "Otesaná meď",
  "block.minecraft.chiseled_deepslate": "Otesaná bridlica",
  "block.minecraft.chiseled_nether_bricks": "Otesané Nether tehly",
  "block.minecraft.chiseled_polished_blackstone": "Otesaný leštený čierny kameň",
  "block.minecraft.chiseled_quartz_block": "Otesaná kocka kremeňa",
  "block.minecraft.chiseled_red_sandstone": "Otesaný červený pieskovec",
  "block.minecraft.chiseled_resin_bricks": "Otesané živicové tehly",
  "block.minecraft.chiseled_sandstone": "Otesaný pieskovec",
  "block.minecraft.chiseled_stone_bricks": "Otesané kamenné tehly",
  "block.minecraft.chiseled_tuff": "Otesaný tuf",
  "block.minecraft.chiseled_tuff_bricks": "Otesané tufové tehly",
  "block.minecraft.chorus_flower": "Chorusový kvet",
  "block.minecraft.chorus_plant": "Chorusová rastlina",
  "block.minecraft.clay": "Íl",
  "block.minecraft.closed_eyeblossom": "Zatvorená zornička",
  "block.minecraft.coal_block": "Kocka uhlia",
  "block.minecraft.coal_ore": "Ložisko uhlia",
  "block.minecraft.coarse_dirt": "Hrubá hlina",
  "block.minecraft.cobbled_deepslate": "Dlažobná bridlica",
  "block.minecraft.cobbled_deepslate_slab": "Stupienok z dlažobnej bridlice",
  "block.minecraft.cobbled_deepslate_stairs": "Schody z dlažobnej bridlice",
  "block.minecraft.cobbled_deepslate_wall": "Múr z dlažobnej bridlice",
  "block.minecraft.cobblestone": "Dlažobný kameň",
  "block.minecraft.cobblestone_slab": "Stupienok z dlažobného kameňa",
  "block.minecraft.cobblestone_stairs": "Schody z dlažobného kameňa",
  "block.minecraft.cobblestone_wall": "Kamenný múr",
  "block.minecraft.cobweb": "Pavučina",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Príkazová kocka",
  "block.minecraft.comparator": "Redstonový porovnávač",
  "block.minecraft.composter": "Kompostér",
  "block.minecraft.conduit": "Silovod",
  "block.minecraft.copper_bars": "Medené mreže",
  "block.minecraft.copper_block": "Kocka medi",
  "block.minecraft.copper_bulb": "Medená žiarovka",
  "block.minecraft.copper_chain": "Medená reťaz",
  "block.minecraft.copper_chest": "Medená truhlica",
  "block.minecraft.copper_door": "Medené dvere",
  "block.minecraft.copper_golem_statue": "Soška medeného golema",
  "block.minecraft.copper_grate": "Medená mriežka",
  "block.minecraft.copper_lantern": "Medený lampáš",
  "block.minecraft.copper_ore": "Medená ruda",
  "block.minecraft.copper_torch": "Medená fakľa",
  "block.minecraft.copper_trapdoor": "Medený poklop",
  "block.minecraft.copper_wall_torch": "Nástenná medená fakľa",
  "block.minecraft.cornflower": "Nevädza",
  "block.minecraft.cracked_deepslate_bricks": "Popraskané bridlicové tehly",
  "block.minecraft.cracked_deepslate_tiles": "Popraskané bridlicové dlaždice",
  "block.minecraft.cracked_nether_bricks": "Popraskané Nether tehly",
  "block.minecraft.cracked_polished_blackstone_bricks": "Popraskané tehly z lešteného čierneho kameňa",
  "block.minecraft.cracked_stone_bricks": "Popraskané kamenné tehly",
  "block.minecraft.crafter": "Výrobník",
  "block.minecraft.crafting_table": "Pracovný stôl",
  "block.minecraft.creaking_heart": "Srdce škripotu",
  "block.minecraft.creeper_head": "Hlava creepera",
  "block.minecraft.creeper_wall_head": "Nástenná hlava creepera",
  "block.minecraft.crimson_button": "Karmínové tlačidlo",
  "block.minecraft.crimson_door": "Karmínové dvere",
  "block.minecraft.crimson_fence": "Karmínový plot",
  "block.minecraft.crimson_fence_gate": "Karmínová bránka",
  "block.minecraft.crimson_fungus": "Karmínová huba",
  "block.minecraft.crimson_hanging_sign": "Karmínová závesná ceduľa",
  "block.minecraft.crimson_hyphae": "Karmínová stielka",
  "block.minecraft.crimson_nylium": "Karmínové podhubie",
  "block.minecraft.crimson_planks": "Karmínové dosky",
  "block.minecraft.crimson_pressure_plate": "Karmínová nášľapná doska",
  "block.minecraft.crimson_roots": "Karmínové korienky",
  "block.minecraft.crimson_shelf": "Karmínová polička",
  "block.minecraft.crimson_sign": "Karmínová ceduľa",
  "block.minecraft.crimson_slab": "Karmínový stupienok",
  "block.minecraft.crimson_stairs": "Karmínové schody",
  "block.minecraft.crimson_stem": "Karmínový hlúbik",
  "block.minecraft.crimson_trapdoor": "Karmínový poklop",
  "block.minecraft.crimson_wall_hanging_sign": "Nástenná karmínová závesná ceduľa",
  "block.minecraft.crimson_wall_sign": "Nástenná karmínová ceduľa",
  "block.minecraft.crying_obsidian": "Slziaci obsidián",
  "block.minecraft.cut_copper": "Tepaná meď",
  "block.minecraft.cut_copper_slab": "Stupienok z tepanej medi",
  "block.minecraft.cut_copper_stairs": "Schody z tepanej medi",
  "block.minecraft.cut_red_sandstone": "Rezaný červený pieskovec",
  "block.minecraft.cut_red_sandstone_slab": "Stupienok z rezaného červeného pieskovca",
  "block.minecraft.cut_sandstone": "Rezaný pieskovec",
  "block.minecraft.cut_sandstone_slab": "Stupienok z rezaného pieskovca",
  "block.minecraft.cyan_banner": "Tyrkysová zástava",
  "block.minecraft.cyan_bed": "Tyrkysová posteľ",
  "block.minecraft.cyan_candle": "Tyrkysová sviečka",
  "block.minecraft.cyan_candle_cake": "Torta s tyrkysovou sviečkou",
  "block.minecraft.cyan_carpet": "Tyrkysový koberec",
  "block.minecraft.cyan_concrete": "Tyrkysový betón",
  "block.minecraft.cyan_concrete_powder": "Tyrkysový cement",
  "block.minecraft.cyan_glazed_terracotta": "Tyrkysová glazovaná terakota",
  "block.minecraft.cyan_shulker_box": "Tyrkysová Shulker schránka",
  "block.minecraft.cyan_stained_glass": "Tyrkysové sklo",
  "block.minecraft.cyan_stained_glass_pane": "Tyrkysový sklenený panel",
  "block.minecraft.cyan_terracotta": "Tyrkysová terakota",
  "block.minecraft.cyan_wool": "Tyrkysová vlna",
  "block.minecraft.damaged_anvil": "Poškodená nákova",
  "block.minecraft.dandelion": "Púpava",
  "block.minecraft.dark_oak_button": "Tlačidlo z tmavého dubu",
  "block.minecraft.dark_oak_door": "Dvere z tmavého dubu",
  "block.minecraft.dark_oak_fence": "Plot z tmavého dubu",
  "block.minecraft.dark_oak_fence_gate": "Bránka z tmavého dubu",
  "block.minecraft.dark_oak_hanging_sign": "Závesná ceduľa z tmavého dubu",
  "block.minecraft.dark_oak_leaves": "Listy tmavého dubu",
  "block.minecraft.dark_oak_log": "Kmeň tmavého dubu",
  "block.minecraft.dark_oak_planks": "Dosky z tmavého dubu",
  "block.minecraft.dark_oak_pressure_plate": "Nášľapná doska z tmavého dubu",
  "block.minecraft.dark_oak_sapling": "Sadenica tmavého dubu",
  "block.minecraft.dark_oak_shelf": "Polička z tmavého dubu",
  "block.minecraft.dark_oak_sign": "Ceduľa z tmavého dubu",
  "block.minecraft.dark_oak_slab": "Stupienok z tmavého dubu",
  "block.minecraft.dark_oak_stairs": "Schody z tmavého dubu",
  "block.minecraft.dark_oak_trapdoor": "Poklop z tmavého dubu",
  "block.minecraft.dark_oak_wall_hanging_sign": "Nástenná závesná ceduľa z tmavého dubu",
  "block.minecraft.dark_oak_wall_sign": "Nástenná ceduľa z tmavého dubu",
  "block.minecraft.dark_oak_wood": "Drevo z tmavého dubu",
  "block.minecraft.dark_prismarine": "Tmavý prizmarín",
  "block.minecraft.dark_prismarine_slab": "Stupienok z tmavého prizmarínu",
  "block.minecraft.dark_prismarine_stairs": "Schody z tmavého prizmarínu",
  "block.minecraft.daylight_detector": "Detektor denného svetla",
  "block.minecraft.dead_brain_coral": "Uhynutý mozgovitý koral",
  "block.minecraft.dead_brain_coral_block": "Kocka uhynutého mozgovitého koralu",
  "block.minecraft.dead_brain_coral_fan": "Vejár uhynutého mozgovitého koralu",
  "block.minecraft.dead_brain_coral_wall_fan": "Nástenný vejár uhynutého mozgovitého koralu",
  "block.minecraft.dead_bubble_coral": "Uhynutý bobuľovitý koral",
  "block.minecraft.dead_bubble_coral_block": "Kocka uhynutého bobuľovitého koralu",
  "block.minecraft.dead_bubble_coral_fan": "Vejár uhynutého bobuľovitého koralu",
  "block.minecraft.dead_bubble_coral_wall_fan": "Nástenný vejár uhynutého bobuľovitého koralu",
  "block.minecraft.dead_bush": "Suchý krík",
  "block.minecraft.dead_fire_coral": "Uhynutý plameňovitý koral",
  "block.minecraft.dead_fire_coral_block": "Kocka uhynutého plameňovitého koralu",
  "block.minecraft.dead_fire_coral_fan": "Vejár uhynutého plameňovitého koralu",
  "block.minecraft.dead_fire_coral_wall_fan": "Nástenný vejár uhynutého plameňovitého koralu",
  "block.minecraft.dead_horn_coral": "Uhynutý parohovitý koral",
  "block.minecraft.dead_horn_coral_block": "Kocka uhynutého parohovitého koralu",
  "block.minecraft.dead_horn_coral_fan": "Vejár uhynutého parohovitého koralu",
  "block.minecraft.dead_horn_coral_wall_fan": "Nástenný vejár uhynutého parohovitého koralu",
  "block.minecraft.dead_tube_coral": "Uhynutý rúrkovitý koral",
  "block.minecraft.dead_tube_coral_block": "Kocka uhynutého rúrkovitého koralu",
  "block.minecraft.dead_tube_coral_fan": "Vejár uhynutého rúrkovitého koralu",
  "block.minecraft.dead_tube_coral_wall_fan": "Nástenný vejár uhynutého rúrkovitého koralu",
  "block.minecraft.decorated_pot": "Ozdobný džbán",
  "block.minecraft.deepslate": "Bridlica",
  "block.minecraft.deepslate_brick_slab": "Stupienok z bridlicových tehál",
  "block.minecraft.deepslate_brick_stairs": "Schody z bridlicových tehál",
  "block.minecraft.deepslate_brick_wall": "Múr z bridlicových tehál",
  "block.minecraft.deepslate_bricks": "Bridlicové tehly",
  "block.minecraft.deepslate_coal_ore": "Bridlicové ložisko uhlia",
  "block.minecraft.deepslate_copper_ore": "Bridlicová medená ruda",
  "block.minecraft.deepslate_diamond_ore": "Bridlicové ložisko diamantu",
  "block.minecraft.deepslate_emerald_ore": "Bridlicové ložisko smaragdu",
  "block.minecraft.deepslate_gold_ore": "Bridlicová zlatá ruda",
  "block.minecraft.deepslate_iron_ore": "Bridlicová železná ruda",
  "block.minecraft.deepslate_lapis_ore": "Bridlicové ložisko lazuritu",
  "block.minecraft.deepslate_redstone_ore": "Bridlicové ložisko redstonu",
  "block.minecraft.deepslate_tile_slab": "Stupienok z bridlicových dlaždíc",
  "block.minecraft.deepslate_tile_stairs": "Schody z bridlicových dlaždíc",
  "block.minecraft.deepslate_tile_wall": "Múr z bridlicových dlaždíc",
  "block.minecraft.deepslate_tiles": "Bridlicové dlaždice",
  "block.minecraft.detector_rail": "Koľajnice so senzorom",
  "block.minecraft.diamond_block": "Diamantová kocka",
  "block.minecraft.diamond_ore": "Ložisko diamantu",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritový stupienok",
  "block.minecraft.diorite_stairs": "Dioritové schody",
  "block.minecraft.diorite_wall": "Dioritový múr",
  "block.minecraft.dirt": "Hlina",
  "block.minecraft.dirt_path": "Udupaná zem",
  "block.minecraft.dispenser": "Dávkovač",
  "block.minecraft.dragon_egg": "Dračie vajce",
  "block.minecraft.dragon_head": "Dračia hlava",
  "block.minecraft.dragon_wall_head": "Nástenná dračia hlava",
  "block.minecraft.dried_ghast": "Vyschnutý ghast",
  "block.minecraft.dried_kelp_block": "Kocka sušených chalúh",
  "block.minecraft.dripstone_block": "Kocka kvapľa",
  "block.minecraft.dropper": "Vyhadzovač",
  "block.minecraft.emerald_block": "Smaragdová kocka",
  "block.minecraft.emerald_ore": "Ložisko smaragdu",
  "block.minecraft.enchanting_table": "Stôl očarovania",
  "block.minecraft.end_gateway": "Brána do Endu",
  "block.minecraft.end_portal": "Portál do Endu",
  "block.minecraft.end_portal_frame": "Rám portálu do Endu",
  "block.minecraft.end_rod": "Endová tyč",
  "block.minecraft.end_stone": "Enderit",
  "block.minecraft.end_stone_brick_slab": "Stupienok z enderitových tehál",
  "block.minecraft.end_stone_brick_stairs": "Schody z enderitových tehál",
  "block.minecraft.end_stone_brick_wall": "Múr z enderitových tehál",
  "block.minecraft.end_stone_bricks": "Enderitové tehly",
  "block.minecraft.ender_chest": "Ender truhlica",
  "block.minecraft.exposed_chiseled_copper": "Zájdená otesaná meď",
  "block.minecraft.exposed_copper": "Zájdená meď",
  "block.minecraft.exposed_copper_bars": "Zájdené medené mreže",
  "block.minecraft.exposed_copper_bulb": "Zájdená medená žiarovka",
  "block.minecraft.exposed_copper_chain": "Zájdená medená reťaz",
  "block.minecraft.exposed_copper_chest": "Zájdená medená truhlica",
  "block.minecraft.exposed_copper_door": "Zájdené medené dvere",
  "block.minecraft.exposed_copper_golem_statue": "Zájdená soška medeného golema",
  "block.minecraft.exposed_copper_grate": "Zájdená medená mriežka",
  "block.minecraft.exposed_copper_lantern": "Zájdený medený lampáš",
  "block.minecraft.exposed_copper_trapdoor": "Zájdený medený poklop",
  "block.minecraft.exposed_cut_copper": "Zájdená tepaná meď",
  "block.minecraft.exposed_cut_copper_slab": "Stupienok zo zájdenej tepanej medi",
  "block.minecraft.exposed_cut_copper_stairs": "Schody zo zájdenej tepanej medi",
  "block.minecraft.exposed_lightning_rod": "Zájdený bleskozvod",
  "block.minecraft.farmland": "Zoraná pôda",
  "block.minecraft.fern": "Papraď",
  "block.minecraft.fire": "Oheň",
  "block.minecraft.fire_coral": "Plameňovitý koral",
  "block.minecraft.fire_coral_block": "Kocka plameňovitého koralu",
  "block.minecraft.fire_coral_fan": "Vejár plameňovitého koralu",
  "block.minecraft.fire_coral_wall_fan": "Nástenný vejár plameňovitého koralu",
  "block.minecraft.firefly_bush": "Krík so svetluškami",
  "block.minecraft.fletching_table": "Stôl na výrobu šípov",
  "block.minecraft.flower_pot": "Kvetináč",
  "block.minecraft.flowering_azalea": "Kvitnúca azalka",
  "block.minecraft.flowering_azalea_leaves": "Azalkové listy s kvetmi",
  "block.minecraft.frogspawn": "Žabie vajíčka",
  "block.minecraft.frosted_ice": "Krehký ľad",
  "block.minecraft.furnace": "Pec",
  "block.minecraft.gilded_blackstone": "Pozlátený čierny kameň",
  "block.minecraft.glass": "Sklo",
  "block.minecraft.glass_pane": "Sklenený panel",
  "block.minecraft.glow_lichen": "Žiariaci lišajník",
  "block.minecraft.glowstone": "Svietivec",
  "block.minecraft.gold_block": "Kocka zlata",
  "block.minecraft.gold_ore": "Zlatá ruda",
  "block.minecraft.golden_dandelion": "Zlatá púpava",
  "block.minecraft.granite": "Žula",
  "block.minecraft.granite_slab": "Žulový stupienok",
  "block.minecraft.granite_stairs": "Žulové schody",
  "block.minecraft.granite_wall": "Žulový múr",
  "block.minecraft.grass": "Tráva",
  "block.minecraft.grass_block": "Trávnik",
  "block.minecraft.gravel": "Štrk",
  "block.minecraft.gray_banner": "Sivá zástava",
  "block.minecraft.gray_bed": "Sivá posteľ",
  "block.minecraft.gray_candle": "Sivá sviečka",
  "block.minecraft.gray_candle_cake": "Torta so svetlosivou sviečkou",
  "block.minecraft.gray_carpet": "Sivý koberec",
  "block.minecraft.gray_concrete": "Sivý betón",
  "block.minecraft.gray_concrete_powder": "Sivý cement",
  "block.minecraft.gray_glazed_terracotta": "Sivá glazovaná terakota",
  "block.minecraft.gray_shulker_box": "Sivá Shulker schránka",
  "block.minecraft.gray_stained_glass": "Sivé sklo",
  "block.minecraft.gray_stained_glass_pane": "Sivý sklenený panel",
  "block.minecraft.gray_terracotta": "Sivá terakota",
  "block.minecraft.gray_wool": "Sivá vlna",
  "block.minecraft.green_banner": "Zelená zástava",
  "block.minecraft.green_bed": "Zelená posteľ",
  "block.minecraft.green_candle": "Zelená sviečka",
  "block.minecraft.green_candle_cake": "Torta so zelenou sviečkou",
  "block.minecraft.green_carpet": "Zelený koberec",
  "block.minecraft.green_concrete": "Zelený betón",
  "block.minecraft.green_concrete_powder": "Zelený cement",
  "block.minecraft.green_glazed_terracotta": "Zelená glazovaná terakota",
  "block.minecraft.green_shulker_box": "Zelená Shulker schránka",
  "block.minecraft.green_stained_glass": "Zelené sklo",
  "block.minecraft.green_stained_glass_pane": "Zelený sklenený panel",
  "block.minecraft.green_terracotta": "Zelená terakota",
  "block.minecraft.green_wool": "Zelená vlna",
  "block.minecraft.grindstone": "Brúsny kameň",
  "block.minecraft.hanging_roots": "Visiace korene",
  "block.minecraft.hay_block": "Zväzok sena",
  "block.minecraft.heavy_core": "Ťažké jadro",
  "block.minecraft.heavy_weighted_pressure_plate": "Vážená nášľapná doska (silná)",
  "block.minecraft.honey_block": "Kocka medu",
  "block.minecraft.honeycomb_block": "Kocka medového plástu",
  "block.minecraft.hopper": "Násypník",
  "block.minecraft.horn_coral": "Parohovitý koral",
  "block.minecraft.horn_coral_block": "Kocka parohovitého koralu",
  "block.minecraft.horn_coral_fan": "Vejár parohovitého koralu",
  "block.minecraft.horn_coral_wall_fan": "Nástenný vejár parohovitého koralu",
  "block.minecraft.ice": "Ľad",
  "block.minecraft.infested_chiseled_stone_bricks": "Zamorené otesané kamenné tehly",
  "block.minecraft.infested_cobblestone": "Zamorený dlažobný kameň",
  "block.minecraft.infested_cracked_stone_bricks": "Zamorené popraskané kamenné tehly",
  "block.minecraft.infested_deepslate": "Zamorená bridlica",
  "block.minecraft.infested_mossy_stone_bricks": "Zamorené zarastené kamenné tehly",
  "block.minecraft.infested_stone": "Zamorený kameň",
  "block.minecraft.infested_stone_bricks": "Zamorené kamenné tehly",
  "block.minecraft.iron_bars": "Železné mreže",
  "block.minecraft.iron_block": "Kocka železa",
  "block.minecraft.iron_chain": "Železná reťaz",
  "block.minecraft.iron_door": "Železné dvere",
  "block.minecraft.iron_ore": "Železná ruda",
  "block.minecraft.iron_trapdoor": "Železný poklop",
  "block.minecraft.jack_o_lantern": "Tekvicový lampáš",
  "block.minecraft.jigsaw": "Skladačková kocka",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Džungľové tlačidlo",
  "block.minecraft.jungle_door": "Džungľové dvere",
  "block.minecraft.jungle_fence": "Džungľový plot",
  "block.minecraft.jungle_fence_gate": "Džungľová bránka",
  "block.minecraft.jungle_hanging_sign": "Džungľová závesná ceduľa",
  "block.minecraft.jungle_leaves": "Džungľové listy",
  "block.minecraft.jungle_log": "Džungľový kmeň",
  "block.minecraft.jungle_planks": "Džungľové dosky",
  "block.minecraft.jungle_pressure_plate": "Džungľová nášľapná doska",
  "block.minecraft.jungle_sapling": "Džungľová sadenica",
  "block.minecraft.jungle_shelf": "Džungľová polička",
  "block.minecraft.jungle_sign": "Džungľová ceduľa",
  "block.minecraft.jungle_slab": "Džungľový stupienok",
  "block.minecraft.jungle_stairs": "Džungľové schody",
  "block.minecraft.jungle_trapdoor": "Džungľový poklop",
  "block.minecraft.jungle_wall_hanging_sign": "Nástenná džungľová závesná ceduľa",
  "block.minecraft.jungle_wall_sign": "Nástenná džungľová ceduľa",
  "block.minecraft.jungle_wood": "Džungľové drevo",
  "block.minecraft.kelp": "Chaluha",
  "block.minecraft.kelp_plant": "Stonka chaluhy",
  "block.minecraft.ladder": "Rebrík",
  "block.minecraft.lantern": "Lampáš",
  "block.minecraft.lapis_block": "Kocka lazuritu",
  "block.minecraft.lapis_ore": "Ložisko lazuritu",
  "block.minecraft.large_amethyst_bud": "Veľký ametystový výrastok",
  "block.minecraft.large_fern": "Veľká papraď",
  "block.minecraft.lava": "Láva",
  "block.minecraft.lava_cauldron": "Kotlík s lávou",
  "block.minecraft.leaf_litter": "Opadané lístie",
  "block.minecraft.lectern": "Pult na čítanie",
  "block.minecraft.lever": "Páka",
  "block.minecraft.light": "Svetlo",
  "block.minecraft.light_blue_banner": "Svetlomodrá zástava",
  "block.minecraft.light_blue_bed": "Svetlomodrá posteľ",
  "block.minecraft.light_blue_candle": "Svetlomodrá sviečka",
  "block.minecraft.light_blue_candle_cake": "Torta so svetlomodrou sviečkou",
  "block.minecraft.light_blue_carpet": "Svetlomodrý koberec",
  "block.minecraft.light_blue_concrete": "Svetlomodrý betón",
  "block.minecraft.light_blue_concrete_powder": "Svetlomodrý cement",
  "block.minecraft.light_blue_glazed_terracotta": "Svetlomodrá glazovaná terakota",
  "block.minecraft.light_blue_shulker_box": "Svetlomodrá Shulker schránka",
  "block.minecraft.light_blue_stained_glass": "Svetlomodré sklo",
  "block.minecraft.light_blue_stained_glass_pane": "Svetlomodrý sklenený panel",
  "block.minecraft.light_blue_terracotta": "Svetlomodrá terakota",
  "block.minecraft.light_blue_wool": "Svetlomodrá vlna",
  "block.minecraft.light_gray_banner": "Svetlosivá zástava",
  "block.minecraft.light_gray_bed": "Svetlosivá posteľ",
  "block.minecraft.light_gray_candle": "Svetlosivá sviečka",
  "block.minecraft.light_gray_candle_cake": "Torta so svetlosivou sviečkou",
  "block.minecraft.light_gray_carpet": "Svetlosivý koberec",
  "block.minecraft.light_gray_concrete": "Svetlosivý betón",
  "block.minecraft.light_gray_concrete_powder": "Svetlosivý cement",
  "block.minecraft.light_gray_glazed_terracotta": "Svetlosivá glazovaná terakota",
  "block.minecraft.light_gray_shulker_box": "Svetlosivá Shulker schránka",
  "block.minecraft.light_gray_stained_glass": "Svetlosivé sklo",
  "block.minecraft.light_gray_stained_glass_pane": "Svetlosivý sklenený panel",
  "block.minecraft.light_gray_terracotta": "Svetlosivá terakota",
  "block.minecraft.light_gray_wool": "Svetlosivá vlna",
  "block.minecraft.light_weighted_pressure_plate": "Vážená nášľapná doska (jemná)",
  "block.minecraft.lightning_rod": "Bleskozvod",
  "block.minecraft.lilac": "Orgován",
  "block.minecraft.lily_of_the_valley": "Konvalinka",
  "block.minecraft.lily_pad": "Lekno",
  "block.minecraft.lime_banner": "Svetlozelená zástava",
  "block.minecraft.lime_bed": "Svetlozelená posteľ",
  "block.minecraft.lime_candle": "Svetlozelená sviečka",
  "block.minecraft.lime_candle_cake": "Torta so svetlozelenou sviečkou",
  "block.minecraft.lime_carpet": "Svetlozelený koberec",
  "block.minecraft.lime_concrete": "Svetlozelený betón",
  "block.minecraft.lime_concrete_powder": "Svetlozelený cement",
  "block.minecraft.lime_glazed_terracotta": "Svetlozelená glazovaná terakota",
  "block.minecraft.lime_shulker_box": "Svetlozelená Shulker schránka",
  "block.minecraft.lime_stained_glass": "Svetlozelené sklo",
  "block.minecraft.lime_stained_glass_pane": "Svetlozelený sklenený panel",
  "block.minecraft.lime_terracotta": "Svetlozelená terakota",
  "block.minecraft.lime_wool": "Svetlozelená vlna",
  "block.minecraft.lodestone": "Navigačný kameň",
  "block.minecraft.loom": "Krosná",
  "block.minecraft.magenta_banner": "Purpurová zástava",
  "block.minecraft.magenta_bed": "Purpurová posteľ",
  "block.minecraft.magenta_candle": "Purpurová sviečka",
  "block.minecraft.magenta_candle_cake": "Torta s purpurovou sviečkou",
  "block.minecraft.magenta_carpet": "Purpurový koberec",
  "block.minecraft.magenta_concrete": "Purpurový betón",
  "block.minecraft.magenta_concrete_powder": "Purpurový cement",
  "block.minecraft.magenta_glazed_terracotta": "Purpurová glazovaná terakota",
  "block.minecraft.magenta_shulker_box": "Purpurová Shulker schránka",
  "block.minecraft.magenta_stained_glass": "Purpurové sklo",
  "block.minecraft.magenta_stained_glass_pane": "Purpurový sklenený panel",
  "block.minecraft.magenta_terracotta": "Purpurová terakota",
  "block.minecraft.magenta_wool": "Purpurová vlna",
  "block.minecraft.magma_block": "Kocka magmy",
  "block.minecraft.mangrove_button": "Mangrovové tlačidlo",
  "block.minecraft.mangrove_door": "Mangrovové dvere",
  "block.minecraft.mangrove_fence": "Mangrovový plot",
  "block.minecraft.mangrove_fence_gate": "Mangrovová bránka",
  "block.minecraft.mangrove_hanging_sign": "Mangrovová závesná ceduľa",
  "block.minecraft.mangrove_leaves": "Mangrovové listy",
  "block.minecraft.mangrove_log": "Mangrovový kmeň",
  "block.minecraft.mangrove_planks": "Mangrovové dosky",
  "block.minecraft.mangrove_pressure_plate": "Mangrovová nášľapná doska",
  "block.minecraft.mangrove_propagule": "Mangrovový výhonok",
  "block.minecraft.mangrove_roots": "Mangrovové korene",
  "block.minecraft.mangrove_shelf": "Mangrovová polička",
  "block.minecraft.mangrove_sign": "Mangrovová ceduľa",
  "block.minecraft.mangrove_slab": "Mangrovový stupienok",
  "block.minecraft.mangrove_stairs": "Mangrovové schody",
  "block.minecraft.mangrove_trapdoor": "Mangrovový poklop",
  "block.minecraft.mangrove_wall_hanging_sign": "Nástenná mangrovová závesná ceduľa",
  "block.minecraft.mangrove_wall_sign": "Mangrovová nástenná ceduľa",
  "block.minecraft.mangrove_wood": "Mangrovové drevo",
  "block.minecraft.medium_amethyst_bud": "Stredný ametystový výrastok",
  "block.minecraft.melon": "Melón",
  "block.minecraft.melon_stem": "Melónová stonka",
  "block.minecraft.moss_block": "Kocka machu",
  "block.minecraft.moss_carpet": "Machový koberec",
  "block.minecraft.mossy_cobblestone": "Zarastený dlažobný kameň",
  "block.minecraft.mossy_cobblestone_slab": "Zarastený stupienok z dlažobného kameňa",
  "block.minecraft.mossy_cobblestone_stairs": "Zarastené schody z dlažobného kameňa",
  "block.minecraft.mossy_cobblestone_wall": "Zarastený kamený múr",
  "block.minecraft.mossy_stone_brick_slab": "Zarastený stupienok z kamenných tehál",
  "block.minecraft.mossy_stone_brick_stairs": "Zarastené schody z kamenných tehál",
  "block.minecraft.mossy_stone_brick_wall": "Zarastený múr z kamenných tehál",
  "block.minecraft.mossy_stone_bricks": "Zarastené kamenné tehly",
  "block.minecraft.moving_piston": "Pohyblivý piest",
  "block.minecraft.mud": "Blato",
  "block.minecraft.mud_brick_slab": "Stupienok z hlinených tehál",
  "block.minecraft.mud_brick_stairs": "Schody z hlinených tehál",
  "block.minecraft.mud_brick_wall": "Múr z hlinených tehál",
  "block.minecraft.mud_bricks": "Hlinené tehly",
  "block.minecraft.muddy_mangrove_roots": "Zablatené mangrovové korene",
  "block.minecraft.mushroom_stem": "Hlúbik",
  "block.minecraft.mycelium": "Podhubie",
  "block.minecraft.nether_brick_fence": "Plot z Nether tehál",
  "block.minecraft.nether_brick_slab": "Stupienok z Nether tehál",
  "block.minecraft.nether_brick_stairs": "Schody z Nether tehál",
  "block.minecraft.nether_brick_wall": "Múr z Nether tehál",
  "block.minecraft.nether_bricks": "Nether tehly",
  "block.minecraft.nether_gold_ore": "Netherová zlatá ruda",
  "block.minecraft.nether_portal": "Nether portál",
  "block.minecraft.nether_quartz_ore": "Ložisko Nether kremeňa",
  "block.minecraft.nether_sprouts": "Netherové klíčky",
  "block.minecraft.nether_wart": "Nether bradavica",
  "block.minecraft.nether_wart_block": "Kocka Nether bradavíc",
  "block.minecraft.netherite_block": "Kocka netheritu",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Hudobná kocka",
  "block.minecraft.oak_button": "Dubové tlačidlo",
  "block.minecraft.oak_door": "Dubové dvere",
  "block.minecraft.oak_fence": "Dubový plot",
  "block.minecraft.oak_fence_gate": "Dubová bránka",
  "block.minecraft.oak_hanging_sign": "Dubová závesná ceduľa",
  "block.minecraft.oak_leaves": "Dubové listy",
  "block.minecraft.oak_log": "Dubový kmeň",
  "block.minecraft.oak_planks": "Dubové dosky",
  "block.minecraft.oak_pressure_plate": "Dubová nášľapná doska",
  "block.minecraft.oak_sapling": "Dubová sadenica",
  "block.minecraft.oak_shelf": "Dubová polička",
  "block.minecraft.oak_sign": "Dubová ceduľa",
  "block.minecraft.oak_slab": "Dubový stupienok",
  "block.minecraft.oak_stairs": "Dubové schody",
  "block.minecraft.oak_trapdoor": "Dubový poklop",
  "block.minecraft.oak_wall_hanging_sign": "Nástenná dubová závesná ceduľa",
  "block.minecraft.oak_wall_sign": "Nástenná dubová ceduľa",
  "block.minecraft.oak_wood": "Dubové drevo",
  "block.minecraft.observer": "Pozorovacia kocka",
  "block.minecraft.obsidian": "Obsidián",
  "block.minecraft.ochre_froglight": "Okrový žabosvit",
  "block.minecraft.ominous_banner": "Zlovestná zástava",
  "block.minecraft.open_eyeblossom": "Otvorená zornička",
  "block.minecraft.orange_banner": "Oranžová zástava",
  "block.minecraft.orange_bed": "Oranžová posteľ",
  "block.minecraft.orange_candle": "Oranžová sviečka",
  "block.minecraft.orange_candle_cake": "Torta s oranžovou sviečkou",
  "block.minecraft.orange_carpet": "Oranžový koberec",
  "block.minecraft.orange_concrete": "Oranžový betón",
  "block.minecraft.orange_concrete_powder": "Oranžový cement",
  "block.minecraft.orange_glazed_terracotta": "Oranžová glazovaná terakota",
  "block.minecraft.orange_shulker_box": "Oranžová Shulker schránka",
  "block.minecraft.orange_stained_glass": "Oranžové sklo",
  "block.minecraft.orange_stained_glass_pane": "Oranžový sklenený panel",
  "block.minecraft.orange_terracotta": "Oranžová terakota",
  "block.minecraft.orange_tulip": "Oranžový tulipán",
  "block.minecraft.orange_wool": "Oranžová vlna",
  "block.minecraft.oxeye_daisy": "Margaréta",
  "block.minecraft.oxidized_chiseled_copper": "Skorodovaná otesaná meď",
  "block.minecraft.oxidized_copper": "Skorodovaná meď",
  "block.minecraft.oxidized_copper_bars": "Skorodované medené mreže",
  "block.minecraft.oxidized_copper_bulb": "Skorodovaná medená žiarovka",
  "block.minecraft.oxidized_copper_chain": "Skorodovaná medená reťaz",
  "block.minecraft.oxidized_copper_chest": "Skorodovaná medená truhlica",
  "block.minecraft.oxidized_copper_door": "Skorodované medené dvere",
  "block.minecraft.oxidized_copper_golem_statue": "Skorodovaná soška medeného golema",
  "block.minecraft.oxidized_copper_grate": "Skorodovaná medená mriežka",
  "block.minecraft.oxidized_copper_lantern": "Skorodovaný medený lampáš",
  "block.minecraft.oxidized_copper_trapdoor": "Skorodovaný medený poklop",
  "block.minecraft.oxidized_cut_copper": "Skorodovaná tepaná meď",
  "block.minecraft.oxidized_cut_copper_slab": "Stupienok zo skorodovanej tepanej medi",
  "block.minecraft.oxidized_cut_copper_stairs": "Schody zo skorodovanej tepanej medi",
  "block.minecraft.oxidized_lightning_rod": "Skorodovaný bleskozvod",
  "block.minecraft.packed_ice": "Tvrdý ľad",
  "block.minecraft.packed_mud": "Stvrdnuté blato",
  "block.minecraft.pale_hanging_moss": "Visiaci bledý mach",
  "block.minecraft.pale_moss_block": "Kocka bledého machu",
  "block.minecraft.pale_moss_carpet": "Koberec z bledého machu",
  "block.minecraft.pale_oak_button": "Tlačidlo z bledého dubu",
  "block.minecraft.pale_oak_door": "Dvere z bledého dubu",
  "block.minecraft.pale_oak_fence": "Plot z bledého dubu",
  "block.minecraft.pale_oak_fence_gate": "Bránka z bledého dubu",
  "block.minecraft.pale_oak_hanging_sign": "Závesná ceduľa z bledého dubu",
  "block.minecraft.pale_oak_leaves": "Listy bledého dubu",
  "block.minecraft.pale_oak_log": "Kmeň bledého dubu",
  "block.minecraft.pale_oak_planks": "Dosky z bledého dubu",
  "block.minecraft.pale_oak_pressure_plate": "Nášľapná doska z bledého dubu",
  "block.minecraft.pale_oak_sapling": "Sadenica bledého dubu",
  "block.minecraft.pale_oak_shelf": "Polička z bledého dubu",
  "block.minecraft.pale_oak_sign": "Ceduľa z bledého dubu",
  "block.minecraft.pale_oak_slab": "Stupienok z bledého dubu",
  "block.minecraft.pale_oak_stairs": "Schody z bledého dubu",
  "block.minecraft.pale_oak_trapdoor": "Poklop z bledého dubu",
  "block.minecraft.pale_oak_wall_hanging_sign": "Nástenná závesná ceduľa z bledého dubu",
  "block.minecraft.pale_oak_wall_sign": "Nástenná ceduľa z bledého dubu",
  "block.minecraft.pale_oak_wood": "Drevo z bledého dubu",
  "block.minecraft.pearlescent_froglight": "Perleťový žabosvit",
  "block.minecraft.peony": "Pivónia",
  "block.minecraft.petrified_oak_slab": "Skamenelý dubový stupienok",
  "block.minecraft.piglin_head": "Hlava piglina",
  "block.minecraft.piglin_wall_head": "Nástenná hlava piglina",
  "block.minecraft.pink_banner": "Ružová zástava",
  "block.minecraft.pink_bed": "Ružová posteľ",
  "block.minecraft.pink_candle": "Ružová sviečka",
  "block.minecraft.pink_candle_cake": "Torta s ružovou sviečkou",
  "block.minecraft.pink_carpet": "Ružový koberec",
  "block.minecraft.pink_concrete": "Ružový betón",
  "block.minecraft.pink_concrete_powder": "Ružový cement",
  "block.minecraft.pink_glazed_terracotta": "Ružová glazovaná terakota",
  "block.minecraft.pink_petals": "Ružové lupene",
  "block.minecraft.pink_shulker_box": "Ružová Shulker schránka",
  "block.minecraft.pink_stained_glass": "Ružové sklo",
  "block.minecraft.pink_stained_glass_pane": "Ružový sklenený panel\n",
  "block.minecraft.pink_terracotta": "Ružová terakota",
  "block.minecraft.pink_tulip": "Ružový tulipán",
  "block.minecraft.pink_wool": "Ružová vlna",
  "block.minecraft.piston": "Piest",
  "block.minecraft.piston_head": "Hlava piestu",
  "block.minecraft.pitcher_crop": "Džbánovník",
  "block.minecraft.pitcher_plant": "Džbánovník",
  "block.minecraft.player_head": "Hlava hráča",
  "block.minecraft.player_head.named": "Hlava hráča %s",
  "block.minecraft.player_wall_head": "Nástenná hlava hráča",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Špička kvapľa",
  "block.minecraft.polished_andesite": "Leštený andezit",
  "block.minecraft.polished_andesite_slab": "Stupienok z lešteného andezitu",
  "block.minecraft.polished_andesite_stairs": "Schody z lešteného andezitu",
  "block.minecraft.polished_basalt": "Leštený čadič",
  "block.minecraft.polished_blackstone": "Leštený čierny kameň",
  "block.minecraft.polished_blackstone_brick_slab": "Stupienok z tehál z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_brick_stairs": "Schody z tehál z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_brick_wall": "Múr z tehál z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_bricks": "Tehly z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_button": "Tlačidlo z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_pressure_plate": "Nášľapná doska z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_slab": "Stupienok z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_stairs": "Schody z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_wall": "Múr z lešteného čierneho kameňa",
  "block.minecraft.polished_deepslate": "Leštená bridlica",
  "block.minecraft.polished_deepslate_slab": "Stupienok z leštenej bridlice",
  "block.minecraft.polished_deepslate_stairs": "Schody z leštenej bridlice",
  "block.minecraft.polished_deepslate_wall": "Múr z leštenej bridlice",
  "block.minecraft.polished_diorite": "Leštený diorit",
  "block.minecraft.polished_diorite_slab": "Stupienok z lešteného dioritu",
  "block.minecraft.polished_diorite_stairs": "Schody z lešteného dioritu",
  "block.minecraft.polished_granite": "Leštená žula",
  "block.minecraft.polished_granite_slab": "Stupienok z leštenej žuly",
  "block.minecraft.polished_granite_stairs": "Schody z leštenej žuly",
  "block.minecraft.polished_tuff": "Leštený tuf",
  "block.minecraft.polished_tuff_slab": "Stupienok z lešteného tufu",
  "block.minecraft.polished_tuff_stairs": "Schody z lešteného tufu",
  "block.minecraft.polished_tuff_wall": "Múr z lešteného tufu",
  "block.minecraft.poppy": "Vlčí mak",
  "block.minecraft.potatoes": "Zemiaky",
  "block.minecraft.potted_acacia_sapling": "Akáciová sadenica v kvetináči",
  "block.minecraft.potted_allium": "Okrasný cesnak v kvetináči",
  "block.minecraft.potted_azalea_bush": "Azalka v kvetináči",
  "block.minecraft.potted_azure_bluet": "Houstónia v kvetináči",
  "block.minecraft.potted_bamboo": "Bambus v kvetináči",
  "block.minecraft.potted_birch_sapling": "Brezová sadenica v kvetináči",
  "block.minecraft.potted_blue_orchid": "Modrá orchidea v kvetináči",
  "block.minecraft.potted_brown_mushroom": "Hnedý hríb v kvetináči",
  "block.minecraft.potted_cactus": "Kaktus v kvetináči",
  "block.minecraft.potted_cherry_sapling": "Čerešňová sadenica v kvetináči",
  "block.minecraft.potted_closed_eyeblossom": "Zatvorená zornička v kvetináči",
  "block.minecraft.potted_cornflower": "Nevädza v kvetináči",
  "block.minecraft.potted_crimson_fungus": "Karmínová huba v kvetináči",
  "block.minecraft.potted_crimson_roots": "Karmínové korienky v kvetináči",
  "block.minecraft.potted_dandelion": "Púpava v kvetináči",
  "block.minecraft.potted_dark_oak_sapling": "Sadenica tmavého dubu v kvetináči",
  "block.minecraft.potted_dead_bush": "Suchý krík v kvetináči",
  "block.minecraft.potted_fern": "Papraď v kvetináči",
  "block.minecraft.potted_flowering_azalea_bush": "Kvitnúca azalka v kvetináči",
  "block.minecraft.potted_golden_dandelion": "Zlatá púpava v kvetináči",
  "block.minecraft.potted_jungle_sapling": "Džungľová sadenica v kvetináči",
  "block.minecraft.potted_lily_of_the_valley": "Konvalinka v kvetináči",
  "block.minecraft.potted_mangrove_propagule": "Mangrovový výhonok v kvetináči",
  "block.minecraft.potted_oak_sapling": "Dubová sadenica v kvetináči",
  "block.minecraft.potted_open_eyeblossom": "Otvorená zornička v kvetináči",
  "block.minecraft.potted_orange_tulip": "Oranžový tulipán v kvetináči",
  "block.minecraft.potted_oxeye_daisy": "Margaréta v kvetináči",
  "block.minecraft.potted_pale_oak_sapling": "Sadenica bledého dubu v kvetináči",
  "block.minecraft.potted_pink_tulip": "Ružový tulipán v kvetináči",
  "block.minecraft.potted_poppy": "Vlčí mak v kvetináči",
  "block.minecraft.potted_red_mushroom": "Muchotrávka v kvetináči",
  "block.minecraft.potted_red_tulip": "Červený tulipán v kvetináči",
  "block.minecraft.potted_spruce_sapling": "Smreková sadenica v kvetináči",
  "block.minecraft.potted_torchflower": "Fakľovka v kvetináči",
  "block.minecraft.potted_warped_fungus": "Prízračná huba v kvetináči",
  "block.minecraft.potted_warped_roots": "Prízračné korienky v kvetináči",
  "block.minecraft.potted_white_tulip": "Biely tulipán v kvetináči",
  "block.minecraft.potted_wither_rose": "Witherova ruža v kvetináči",
  "block.minecraft.powder_snow": "Prašný sneh",
  "block.minecraft.powder_snow_cauldron": "Kotlík s prašným snehom",
  "block.minecraft.powered_rail": "Napájané koľajnice",
  "block.minecraft.prismarine": "Prizmarín",
  "block.minecraft.prismarine_brick_slab": "Stupienok z prizmarínových tehál",
  "block.minecraft.prismarine_brick_stairs": "Schody z prizmarínových tehál",
  "block.minecraft.prismarine_bricks": "Prizmarínové tehly",
  "block.minecraft.prismarine_slab": "Prizmarínový stupienok",
  "block.minecraft.prismarine_stairs": "Schody z prizmarínu",
  "block.minecraft.prismarine_wall": "Prizmarínový múr",
  "block.minecraft.pumpkin": "Tekvica",
  "block.minecraft.pumpkin_stem": "Tekvicová stonka",
  "block.minecraft.purple_banner": "Fialová zástava",
  "block.minecraft.purple_bed": "Fialová posteľ",
  "block.minecraft.purple_candle": "Fialová sviečka",
  "block.minecraft.purple_candle_cake": "Torta s fialovou sviečkou",
  "block.minecraft.purple_carpet": "Fialový koberec",
  "block.minecraft.purple_concrete": "Fialový betón",
  "block.minecraft.purple_concrete_powder": "Fialový cement",
  "block.minecraft.purple_glazed_terracotta": "Fialová glazovaná terakota",
  "block.minecraft.purple_shulker_box": "Fialová Shulker schránka",
  "block.minecraft.purple_stained_glass": "Fialové sklo",
  "block.minecraft.purple_stained_glass_pane": "Fialový sklenený panel",
  "block.minecraft.purple_terracotta": "Fialová terakota",
  "block.minecraft.purple_wool": "Fialová vlna",
  "block.minecraft.purpur_block": "Purpurová kocka",
  "block.minecraft.purpur_pillar": "Purpurový stĺp",
  "block.minecraft.purpur_slab": "Purpurový stupienok",
  "block.minecraft.purpur_stairs": "Purpurové schody",
  "block.minecraft.quartz_block": "Kocka kremeňa",
  "block.minecraft.quartz_bricks": "Kremenné tehly",
  "block.minecraft.quartz_pillar": "Kremenný stĺp",
  "block.minecraft.quartz_slab": "Kremenný stupienok",
  "block.minecraft.quartz_stairs": "Kremenné schody",
  "block.minecraft.rail": "Koľajnice",
  "block.minecraft.raw_copper_block": "Kocka surovej medi",
  "block.minecraft.raw_gold_block": "Kocka surového zlata",
  "block.minecraft.raw_iron_block": "Kocka surového železa",
  "block.minecraft.red_banner": "Červená zástava",
  "block.minecraft.red_bed": "Červená posteľ",
  "block.minecraft.red_candle": "Červená sviečka",
  "block.minecraft.red_candle_cake": "Torta s červenou sviečkou",
  "block.minecraft.red_carpet": "Červený koberec",
  "block.minecraft.red_concrete": "Červený betón",
  "block.minecraft.red_concrete_powder": "Červený cement",
  "block.minecraft.red_glazed_terracotta": "Červená glazovaná terakota",
  "block.minecraft.red_mushroom": "Muchotrávka",
  "block.minecraft.red_mushroom_block": "Muchotrávková kocka",
  "block.minecraft.red_nether_brick_slab": "Stupienok z červených Nether tehál",
  "block.minecraft.red_nether_brick_stairs": "Schody z červených Nether tehál",
  "block.minecraft.red_nether_brick_wall": "Múr z červených Nether tehál",
  "block.minecraft.red_nether_bricks": "Červené Nether tehly",
  "block.minecraft.red_sand": "Červený piesok",
  "block.minecraft.red_sandstone": "Červený pieskovec",
  "block.minecraft.red_sandstone_slab": "Stupienok z červeného pieskovca",
  "block.minecraft.red_sandstone_stairs": "Schody z červeného pieskovca",
  "block.minecraft.red_sandstone_wall": "Múr z červeného pieskovca",
  "block.minecraft.red_shulker_box": "Červená Shulker schránka",
  "block.minecraft.red_stained_glass": "Červené sklo",
  "block.minecraft.red_stained_glass_pane": "Červený sklenený panel",
  "block.minecraft.red_terracotta": "Červená terakota",
  "block.minecraft.red_tulip": "Červený tulipán",
  "block.minecraft.red_wool": "Červená vlna",
  "block.minecraft.redstone_block": "Kocka redstonu",
  "block.minecraft.redstone_lamp": "Redstonová lampa",
  "block.minecraft.redstone_ore": "Ložisko redstonu",
  "block.minecraft.redstone_torch": "Redstonová fakľa",
  "block.minecraft.redstone_wall_torch": "Nástenná redstonová fakľa",
  "block.minecraft.redstone_wire": "Redstonový vodič",
  "block.minecraft.reinforced_deepslate": "Vystužená bridlica",
  "block.minecraft.repeater": "Redstonový opakovač",
  "block.minecraft.repeating_command_block": "Opakujúca príkazová kocka",
  "block.minecraft.resin_block": "Kocka živice",
  "block.minecraft.resin_brick_slab": "Schodík zo živicových tehál",
  "block.minecraft.resin_brick_stairs": "Schody zo živicových tehál",
  "block.minecraft.resin_brick_wall": "Múr zo živicových tehál",
  "block.minecraft.resin_bricks": "Živicové tehly",
  "block.minecraft.resin_clump": "Hrudka živice",
  "block.minecraft.respawn_anchor": "Kotva oživenia",
  "block.minecraft.rooted_dirt": "Prerastená hlina",
  "block.minecraft.rose_bush": "Ružový krík",
  "block.minecraft.sand": "Piesok",
  "block.minecraft.sandstone": "Pieskovec",
  "block.minecraft.sandstone_slab": "Pieskovcový stupienok",
  "block.minecraft.sandstone_stairs": "Pieskovcové schody",
  "block.minecraft.sandstone_wall": "Pieskovcový múr",
  "block.minecraft.scaffolding": "Lešenie",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkový katalyzátor",
  "block.minecraft.sculk_sensor": "Sculk snímač",
  "block.minecraft.sculk_shrieker": "Sculkový škriekač",
  "block.minecraft.sculk_vein": "Sculková žila",
  "block.minecraft.sea_lantern": "Morský lampáš",
  "block.minecraft.sea_pickle": "Morská uhorka",
  "block.minecraft.seagrass": "Morská tráva",
  "block.minecraft.set_spawn": "Miesto oživenia nastavené",
  "block.minecraft.short_dry_grass": "Nízka suchá tráva",
  "block.minecraft.short_grass": "Nízka tráva",
  "block.minecraft.shroomlight": "Lampiňón",
  "block.minecraft.shulker_box": "Shulker schránka",
  "block.minecraft.skeleton_skull": "Lebka kostlivca",
  "block.minecraft.skeleton_wall_skull": "Nástenná lebka kostlivca",
  "block.minecraft.slime_block": "Kocka slizu",
  "block.minecraft.small_amethyst_bud": "Malý ametystový výrastok",
  "block.minecraft.small_dripleaf": "Malý kvapkavec",
  "block.minecraft.smithing_table": "Kováčsky stôl",
  "block.minecraft.smoker": "Udiareň",
  "block.minecraft.smooth_basalt": "Hladký čadič",
  "block.minecraft.smooth_quartz": "Kocka hladkého kremeňa",
  "block.minecraft.smooth_quartz_slab": "Stupienok z hladkého kremeňa",
  "block.minecraft.smooth_quartz_stairs": "Schody z hladkého kremeňa",
  "block.minecraft.smooth_red_sandstone": "Hladký červený pieskovec",
  "block.minecraft.smooth_red_sandstone_slab": "Stupienok z hladkého červeného pieskovca",
  "block.minecraft.smooth_red_sandstone_stairs": "Schody z hladkého červeného pieskovca",
  "block.minecraft.smooth_sandstone": "Hladký pieskovec",
  "block.minecraft.smooth_sandstone_slab": "Stupienok z hladkého pieskovca",
  "block.minecraft.smooth_sandstone_stairs": "Schody z hladkého pieskovca",
  "block.minecraft.smooth_stone": "Hladký kameň",
  "block.minecraft.smooth_stone_slab": "Stupienok z hladkého kameňa",
  "block.minecraft.sniffer_egg": "Vajce ňuchača",
  "block.minecraft.snow": "Sneh",
  "block.minecraft.snow_block": "Kocka snehu",
  "block.minecraft.soul_campfire": "Táborák s ohňom duší",
  "block.minecraft.soul_fire": "Oheň duší",
  "block.minecraft.soul_lantern": "Lampáš s ohňom duší",
  "block.minecraft.soul_sand": "Piesok duší",
  "block.minecraft.soul_soil": "Pôda duší",
  "block.minecraft.soul_torch": "Fakľa s ohňom duší",
  "block.minecraft.soul_wall_torch": "Nástenná fakľa s ohňom duší",
  "block.minecraft.spawn.not_valid": "Tvoja posteľ alebo nabitá kotva oživenia neexistuje alebo je zablokovaná",
  "block.minecraft.spawner": "Liaheň tvorov",
  "block.minecraft.spawner.desc1": "Interakcia s vajíčkom stvorenia:",
  "block.minecraft.spawner.desc2": "Nastaví typ tvora",
  "block.minecraft.sponge": "Špongia",
  "block.minecraft.spore_blossom": "Výtruska",
  "block.minecraft.spruce_button": "Smrekové tlačidlo",
  "block.minecraft.spruce_door": "Smrekové dvere",
  "block.minecraft.spruce_fence": "Smrekový plot",
  "block.minecraft.spruce_fence_gate": "Smreková bránka",
  "block.minecraft.spruce_hanging_sign": "Smreková závesná ceduľa",
  "block.minecraft.spruce_leaves": "Smrekové ihličie",
  "block.minecraft.spruce_log": "Smrekový kmeň",
  "block.minecraft.spruce_planks": "Smrekové dosky",
  "block.minecraft.spruce_pressure_plate": "Smreková nášľapná doska",
  "block.minecraft.spruce_sapling": "Smreková sadenica",
  "block.minecraft.spruce_shelf": "Smreková polička",
  "block.minecraft.spruce_sign": "Smreková ceduľa",
  "block.minecraft.spruce_slab": "Smrekový stupienok",
  "block.minecraft.spruce_stairs": "Smrekové schody",
  "block.minecraft.spruce_trapdoor": "Smrekový poklop",
  "block.minecraft.spruce_wall_hanging_sign": "Nástenná smreková závesná ceduľa",
  "block.minecraft.spruce_wall_sign": "Nástenná smreková ceduľa",
  "block.minecraft.spruce_wood": "Smrekové drevo",
  "block.minecraft.sticky_piston": "Lepkavý piest",
  "block.minecraft.stone": "Kameň",
  "block.minecraft.stone_brick_slab": "Stupienok z kamenných tehál",
  "block.minecraft.stone_brick_stairs": "Schody z kamenných tehál",
  "block.minecraft.stone_brick_wall": "Múr z kamenných tehál",
  "block.minecraft.stone_bricks": "Kamenné tehly",
  "block.minecraft.stone_button": "Kamenné tlačidlo",
  "block.minecraft.stone_pressure_plate": "Kamenná nášľapná doska",
  "block.minecraft.stone_slab": "Kamenný stupienok",
  "block.minecraft.stone_stairs": "Kamenné schody",
  "block.minecraft.stonecutter": "Píla na kameň",
  "block.minecraft.stripped_acacia_log": "Olúpaný akáciový kmeň",
  "block.minecraft.stripped_acacia_wood": "Olúpané akáciové drevo",
  "block.minecraft.stripped_bamboo_block": "Kocka olúpaného bambusu",
  "block.minecraft.stripped_birch_log": "Olúpaný brezový kmeň",
  "block.minecraft.stripped_birch_wood": "Olúpané brezové drevo",
  "block.minecraft.stripped_cherry_log": "Olúpaný čerešňový kmeň",
  "block.minecraft.stripped_cherry_wood": "Olúpané čerešňové drevo",
  "block.minecraft.stripped_crimson_hyphae": "Olúpaná karmínová stielka",
  "block.minecraft.stripped_crimson_stem": "Olúpaný karmínový hlúbik",
  "block.minecraft.stripped_dark_oak_log": "Olúpaný kmeň tmavého dubu",
  "block.minecraft.stripped_dark_oak_wood": "Olúpané drevo z tmavého dubu",
  "block.minecraft.stripped_jungle_log": "Olúpaný džungľový kmeň",
  "block.minecraft.stripped_jungle_wood": "Olúpané džungľové drevo",
  "block.minecraft.stripped_mangrove_log": "Olúpaný mangrovový kmeň",
  "block.minecraft.stripped_mangrove_wood": "Olúpané mangrovové drevo",
  "block.minecraft.stripped_oak_log": "Olúpaný dubový kmeň",
  "block.minecraft.stripped_oak_wood": "Olúpané dubové drevo",
  "block.minecraft.stripped_pale_oak_log": "Olúpaný kmeň bledého dubu",
  "block.minecraft.stripped_pale_oak_wood": "Olúpané drevo z bledého dubu",
  "block.minecraft.stripped_spruce_log": "Olúpaný smrekový kmeň",
  "block.minecraft.stripped_spruce_wood": "Olúpané smrekové drevo",
  "block.minecraft.stripped_warped_hyphae": "Olúpaná prízračná stielka",
  "block.minecraft.stripped_warped_stem": "Olúpaný prízračný hlúbik",
  "block.minecraft.structure_block": "Štruktúrová kocka",
  "block.minecraft.structure_void": "Štruktúrové prázdno",
  "block.minecraft.sugar_cane": "Cukrová trstina",
  "block.minecraft.sunflower": "Slnečnica",
  "block.minecraft.suspicious_gravel": "Podozrivý štrk",
  "block.minecraft.suspicious_sand": "Podozrivý piesok",
  "block.minecraft.sweet_berry_bush": "Krík sladkých bobúľ",
  "block.minecraft.tall_dry_grass": "Vysoká suchá tráva",
  "block.minecraft.tall_grass": "Vysoká tráva",
  "block.minecraft.tall_seagrass": "Vysoká morská tráva",
  "block.minecraft.target": "Terč",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testovacia kocka",
  "block.minecraft.test_instance_block": "Kocka testovacej inštancie",
  "block.minecraft.tinted_glass": "Tmavé sklo",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Výbuchy TNT sú vypnuté",
  "block.minecraft.torch": "Fakľa",
  "block.minecraft.torchflower": "Fakľovka",
  "block.minecraft.torchflower_crop": "Fakľovka",
  "block.minecraft.trapped_chest": "Truhlica s pascou",
  "block.minecraft.trial_spawner": "Skúšková liaheň",
  "block.minecraft.tripwire": "Nástražná šnúra",
  "block.minecraft.tripwire_hook": "Úchyt nástražnej šnúry",
  "block.minecraft.tube_coral": "Rúrkovitý koral",
  "block.minecraft.tube_coral_block": "Kocka rúrkovitého koralu",
  "block.minecraft.tube_coral_fan": "Vejár rúrkovitého koralu",
  "block.minecraft.tube_coral_wall_fan": "Nástenný vejár rúrkovitého koralu",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Stupienok z tufových tehál",
  "block.minecraft.tuff_brick_stairs": "Schody z tufových tehál",
  "block.minecraft.tuff_brick_wall": "Múr z tufových tehál",
  "block.minecraft.tuff_bricks": "Tufové tehly",
  "block.minecraft.tuff_slab": "Tufový stupienok",
  "block.minecraft.tuff_stairs": "Tufové schody",
  "block.minecraft.tuff_wall": "Tufový múr",
  "block.minecraft.turtle_egg": "Korytnačie vajce",
  "block.minecraft.twisting_vines": "Prízračné liany",
  "block.minecraft.twisting_vines_plant": "Stonka prízračnej liany",
  "block.minecraft.vault": "Pokladnica",
  "block.minecraft.verdant_froglight": "Zelenkavý žabosvit",
  "block.minecraft.vine": "Liany",
  "block.minecraft.void_air": "Vzduch prázdna",
  "block.minecraft.wall_torch": "Nástenná fakľa",
  "block.minecraft.warped_button": "Prízračné tlačidlo",
  "block.minecraft.warped_door": "Prízračné dvere",
  "block.minecraft.warped_fence": "Prízračný plot",
  "block.minecraft.warped_fence_gate": "Prízračná bránka",
  "block.minecraft.warped_fungus": "Prízračná huba",
  "block.minecraft.warped_hanging_sign": "Prízračná závesná ceduľa",
  "block.minecraft.warped_hyphae": "Prízračná stielka",
  "block.minecraft.warped_nylium": "Prízračné podhubie",
  "block.minecraft.warped_planks": "Prízračné dosky",
  "block.minecraft.warped_pressure_plate": "Prízračná nášľapná doska",
  "block.minecraft.warped_roots": "Prízračné korienky",
  "block.minecraft.warped_shelf": "Prízračná polička",
  "block.minecraft.warped_sign": "Prízračná ceduľa",
  "block.minecraft.warped_slab": "Prízračný stupienok",
  "block.minecraft.warped_stairs": "Prízračné schody",
  "block.minecraft.warped_stem": "Prízračný hlúbik",
  "block.minecraft.warped_trapdoor": "Prízračný poklop",
  "block.minecraft.warped_wall_hanging_sign": "Nástenná prízračná závesná ceduľa",
  "block.minecraft.warped_wall_sign": "Nástenná prízračná ceduľa",
  "block.minecraft.warped_wart_block": "Kocka prízračných bradavíc",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotlík s vodou",
  "block.minecraft.waxed_chiseled_copper": "Navoskovaná otesaná meď",
  "block.minecraft.waxed_copper_bars": "Navoskované medené mreže",
  "block.minecraft.waxed_copper_block": "Navoskovaná kocka medi",
  "block.minecraft.waxed_copper_bulb": "Navoskovaná medená žiarovka",
  "block.minecraft.waxed_copper_chain": "Navoskovaná medená reťaz",
  "block.minecraft.waxed_copper_chest": "Navoskovaná medená truhlica",
  "block.minecraft.waxed_copper_door": "Navoskované medené dvere",
  "block.minecraft.waxed_copper_golem_statue": "Navoskovaná soška medeného golema",
  "block.minecraft.waxed_copper_grate": "Navoskovaná medená mriežka",
  "block.minecraft.waxed_copper_lantern": "Navoskovaný medený lampáš",
  "block.minecraft.waxed_copper_trapdoor": "Navoskovaný medený poklop",
  "block.minecraft.waxed_cut_copper": "Navoskovaná tepaná meď",
  "block.minecraft.waxed_cut_copper_slab": "Navoskovaný stupienok z tepanej medi",
  "block.minecraft.waxed_cut_copper_stairs": "Navoskované schody z tepanej medi",
  "block.minecraft.waxed_exposed_chiseled_copper": "Navoskovaná zájdená otesaná meď",
  "block.minecraft.waxed_exposed_copper": "Navoskovaná zájdená meď",
  "block.minecraft.waxed_exposed_copper_bars": "Navoskované zájdené medené mreže",
  "block.minecraft.waxed_exposed_copper_bulb": "Navoskovaná zájdená medená žiarovka",
  "block.minecraft.waxed_exposed_copper_chain": "Navoskovaná zájdená medená reťaz",
  "block.minecraft.waxed_exposed_copper_chest": "Navoskovaná zájdená medená truhlica",
  "block.minecraft.waxed_exposed_copper_door": "Navoskované zájdené medené dvere",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Navoskovaná zájdená soška medeného golema",
  "block.minecraft.waxed_exposed_copper_grate": "Navoskovaná zájdená medená mriežka",
  "block.minecraft.waxed_exposed_copper_lantern": "Navoskovaný zájdený medený lampáš",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Navoskovaný zájdený medený poklop",
  "block.minecraft.waxed_exposed_cut_copper": "Navoskovaná zájdená tepaná meď",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Navoskovaný stupienok zo zájdenej tepanej medi",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Navoskované schody zo zájdenej tepanej medi",
  "block.minecraft.waxed_exposed_lightning_rod": "Navoskovaný zájdený bleskozvod",
  "block.minecraft.waxed_lightning_rod": "Navoskovaný bleskozvod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Navoskovaná skorodovaná otesaná meď",
  "block.minecraft.waxed_oxidized_copper": "Navoskovaná skorodovaná meď",
  "block.minecraft.waxed_oxidized_copper_bars": "Navoskované skorodované medené mreže",
  "block.minecraft.waxed_oxidized_copper_bulb": "Navoskovaná skorodovaná medená žiarovka",
  "block.minecraft.waxed_oxidized_copper_chain": "Navoskovaná skorodovaná medená reťaz",
  "block.minecraft.waxed_oxidized_copper_chest": "Navoskovaná skorodovaná medená truhlica",
  "block.minecraft.waxed_oxidized_copper_door": "Navoskované skorodované medené dvere",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Navoskovaná skorodovaná soška medeného golema",
  "block.minecraft.waxed_oxidized_copper_grate": "Navoskovaná skorodovaná medená mriežka",
  "block.minecraft.waxed_oxidized_copper_lantern": "Navoskovaný skorodovaný medený lampáš",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Navoskovaný skorodovaný medený poklop",
  "block.minecraft.waxed_oxidized_cut_copper": "Navoskovaná skorodovaná tepaná meď",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Navoskovaný stupienok zo skorodovanej tepanej medi",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Navoskované schody zo skorodovanej tepanej medi",
  "block.minecraft.waxed_oxidized_lightning_rod": "Navoskovaný skorodovaný bleskozvod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Navoskovaná zelenkavá otesaná meď",
  "block.minecraft.waxed_weathered_copper": "Navoskovaná zelenkavá meď",
  "block.minecraft.waxed_weathered_copper_bars": "Navoskované zelenkavé medené mreže",
  "block.minecraft.waxed_weathered_copper_bulb": "Navoskovaná zelenkavá medená žiarovka",
  "block.minecraft.waxed_weathered_copper_chain": "Navoskovaná zelenkavá medená reťaz",
  "block.minecraft.waxed_weathered_copper_chest": "Navoskovaná zelenkavá medená truhlica",
  "block.minecraft.waxed_weathered_copper_door": "Navoskované zelenkavé medené dvere",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Navoskovaná zelenkavá soška medeného golema",
  "block.minecraft.waxed_weathered_copper_grate": "Navoskovaná zelenkavá medená mriežka",
  "block.minecraft.waxed_weathered_copper_lantern": "Navoskovaný zelenkavý medený lampáš",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Navoskovaný zelenkavý medený poklop",
  "block.minecraft.waxed_weathered_cut_copper": "Navoskovaná zelenkavá tepaná meď",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Navoskovaný stupienok zo zelenkavej tepanej medi",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Navoskované schody zo zelenkavej tepanej medi",
  "block.minecraft.waxed_weathered_lightning_rod": "Navoskovaný zelenkavý bleskozvod",
  "block.minecraft.weathered_chiseled_copper": "Zelenkavá otesaná meď",
  "block.minecraft.weathered_copper": "Zelenkavá meď",
  "block.minecraft.weathered_copper_bars": "Zelenkavé medené mreže",
  "block.minecraft.weathered_copper_bulb": "Zelenkavá medená žiarovka",
  "block.minecraft.weathered_copper_chain": "Zelenkavá medená reťaz",
  "block.minecraft.weathered_copper_chest": "Zelenkavá medená truhlica",
  "block.minecraft.weathered_copper_door": "Zelenkavé medené dvere",
  "block.minecraft.weathered_copper_golem_statue": "Zelenkavá soška medeného golema",
  "block.minecraft.weathered_copper_grate": "Zelenkavá medená mriežka",
  "block.minecraft.weathered_copper_lantern": "Zelenkavý medený lampáš",
  "block.minecraft.weathered_copper_trapdoor": "Zelenkavý medený poklop",
  "block.minecraft.weathered_cut_copper": "Zelenkavá tepaná meď",
  "block.minecraft.weathered_cut_copper_slab": "Stupienok zo zelenkavej tepanej medi",
  "block.minecraft.weathered_cut_copper_stairs": "Schody zo zelenkavej tepanej medi",
  "block.minecraft.weathered_lightning_rod": "Zelenkavý bleskozvod",
  "block.minecraft.weeping_vines": "Karmínové liany",
  "block.minecraft.weeping_vines_plant": "Stonka karmínovej liany",
  "block.minecraft.wet_sponge": "Vlhká špongia",
  "block.minecraft.wheat": "Pšenica",
  "block.minecraft.white_banner": "Biela zástava",
  "block.minecraft.white_bed": "Biela posteľ",
  "block.minecraft.white_candle": "Biela sviečka",
  "block.minecraft.white_candle_cake": "Torta s bielou sviečkou",
  "block.minecraft.white_carpet": "Biely koberec",
  "block.minecraft.white_concrete": "Biely betón",
  "block.minecraft.white_concrete_powder": "Biely cement",
  "block.minecraft.white_glazed_terracotta": "Biela glazovaná terakota",
  "block.minecraft.white_shulker_box": "Biela Shulker schránka",
  "block.minecraft.white_stained_glass": "Biele sklo",
  "block.minecraft.white_stained_glass_pane": "Biely sklenený panel",
  "block.minecraft.white_terracotta": "Biela terakota",
  "block.minecraft.white_tulip": "Biely tulipán",
  "block.minecraft.white_wool": "Biela vlna",
  "block.minecraft.wildflowers": "Divé kvety",
  "block.minecraft.wither_rose": "Witherova ruža",
  "block.minecraft.wither_skeleton_skull": "Lebka Wither kostlivca",
  "block.minecraft.wither_skeleton_wall_skull": "Nástenná lebka Wither kostlivca",
  "block.minecraft.yellow_banner": "Žltá zástava",
  "block.minecraft.yellow_bed": "Žltá posteľ",
  "block.minecraft.yellow_candle": "Žltá sviečka",
  "block.minecraft.yellow_candle_cake": "Torta so žltou sviečkou",
  "block.minecraft.yellow_carpet": "Žltý koberec",
  "block.minecraft.yellow_concrete": "Žltý betón",
  "block.minecraft.yellow_concrete_powder": "Žltý cement",
  "block.minecraft.yellow_glazed_terracotta": "Žltá glazovaná terakota",
  "block.minecraft.yellow_shulker_box": "Žltá Shulker schránka",
  "block.minecraft.yellow_stained_glass": "Žlté sklo",
  "block.minecraft.yellow_stained_glass_pane": "Žltý sklenený panel",
  "block.minecraft.yellow_terracotta": "Žltá terakota",
  "block.minecraft.yellow_wool": "Žltá vlna",
  "block.minecraft.zombie_head": "Hlava zombíka",
  "block.minecraft.zombie_wall_head": "Nástenná hlava zombíka",
  "item.minecraft.acacia_boat": "Akáciový čln",
  "item.minecraft.acacia_chest_boat": "Akáciový čln s truhlicou",
  "item.minecraft.allay_spawn_egg": "Vajíčko s alíkom",
  "item.minecraft.amethyst_shard": "Ametystový úlomok",
  "item.minecraft.angler_pottery_shard": "Črep s rybárom",
  "item.minecraft.angler_pottery_sherd": "Črep s rybárom",
  "item.minecraft.apple": "Jablko",
  "item.minecraft.archer_pottery_shard": "Črep s lukom",
  "item.minecraft.archer_pottery_sherd": "Črep s lukom",
  "item.minecraft.armadillo_scute": "Doštička pásavca",
  "item.minecraft.armadillo_spawn_egg": "Vajíčko s pásavcom",
  "item.minecraft.armor_stand": "Stojan na brnenie",
  "item.minecraft.arms_up_pottery_shard": "Črep s rukami nad hlavou",
  "item.minecraft.arms_up_pottery_sherd": "Črep s rukami nad hlavou",
  "item.minecraft.arrow": "Šíp",
  "item.minecraft.axolotl_bucket": "Vedro s axolotlom",
  "item.minecraft.axolotl_spawn_egg": "Vajíčko s axolotlom",
  "item.minecraft.baked_potato": "Pečený zemiak",
  "item.minecraft.bamboo_chest_raft": "Bambusová plť s truhlicou",
  "item.minecraft.bamboo_raft": "Bambusová plť",
  "item.minecraft.bat_spawn_egg": "Vajíčko s netopierom",
  "item.minecraft.bee_spawn_egg": "Vajíčko so včelou",
  "item.minecraft.beef": "Surové hovädzie",
  "item.minecraft.beetroot": "Repa",
  "item.minecraft.beetroot_seeds": "Semienka repy",
  "item.minecraft.beetroot_soup": "Boršč",
  "item.minecraft.birch_boat": "Brezový čln",
  "item.minecraft.birch_chest_boat": "Brezový čln s truhlicou",
  "item.minecraft.black_bundle": "Čierny balíček",
  "item.minecraft.black_dye": "Čierne farbivo",
  "item.minecraft.black_harness": "Čierny postroj",
  "item.minecraft.blade_pottery_shard": "Črep s mečom",
  "item.minecraft.blade_pottery_sherd": "Črep s mečom",
  "item.minecraft.blaze_powder": "Prach ohniváka",
  "item.minecraft.blaze_rod": "Tyč Ohniváka",
  "item.minecraft.blaze_spawn_egg": "Vajíčko s ohnivákom",
  "item.minecraft.blue_bundle": "Modrý balíček",
  "item.minecraft.blue_dye": "Modré farbivo",
  "item.minecraft.blue_egg": "Modré vajce",
  "item.minecraft.blue_harness": "Modrý postroj",
  "item.minecraft.bogged_spawn_egg": "Vajíčko s vodníkom",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornament matice",
  "item.minecraft.bone": "Kosť",
  "item.minecraft.bone_meal": "Kostná múčka",
  "item.minecraft.book": "Kniha",
  "item.minecraft.bordure_indented_banner_pattern": "Vzor zástavy: lem",
  "item.minecraft.bow": "Luk",
  "item.minecraft.bowl": "Miska",
  "item.minecraft.bread": "Chlieb",
  "item.minecraft.breeze_rod": "Tyč Víchra",
  "item.minecraft.breeze_spawn_egg": "Vajíčko s víchrom",
  "item.minecraft.brewer_pottery_shard": "Črep varenia",
  "item.minecraft.brewer_pottery_sherd": "Črep varenia",
  "item.minecraft.brewing_stand": "Varný stojan",
  "item.minecraft.brick": "Tehla",
  "item.minecraft.brown_bundle": "Hnedý balíček",
  "item.minecraft.brown_dye": "Hnedé farbivo",
  "item.minecraft.brown_egg": "Hnedé vajce",
  "item.minecraft.brown_harness": "Hnedý postroj",
  "item.minecraft.brush": "Metlička",
  "item.minecraft.bucket": "Vedro",
  "item.minecraft.bundle": "Balíček",
  "item.minecraft.bundle.empty": "Prázdny",
  "item.minecraft.bundle.empty.description": "Môže obsahovať zmiešanú hromadu predmetov",
  "item.minecraft.bundle.full": "Plný",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Črep s plameňom",
  "item.minecraft.burn_pottery_sherd": "Črep s plameňom",
  "item.minecraft.camel_husk_spawn_egg": "Vajíčko s ťavím zdochliakom",
  "item.minecraft.camel_spawn_egg": "Vajíčko s ťavou",
  "item.minecraft.carrot": "Mrkva",
  "item.minecraft.carrot_on_a_stick": "Mrkva na udici",
  "item.minecraft.cat_spawn_egg": "Vajíčko s mačkou",
  "item.minecraft.cauldron": "Kotlík",
  "item.minecraft.cave_spider_spawn_egg": "Vajíčko s jaskynným pavúkom",
  "item.minecraft.chainmail_boots": "Krúžkové topánky",
  "item.minecraft.chainmail_chestplate": "Krúžkové brnenie",
  "item.minecraft.chainmail_helmet": "Krúžková prilba",
  "item.minecraft.chainmail_leggings": "Krúžkové nohavice",
  "item.minecraft.charcoal": "Drevené uhlie",
  "item.minecraft.cherry_boat": "Čerešňový čln",
  "item.minecraft.cherry_chest_boat": "Čerešňový čln s truhlicou",
  "item.minecraft.chest_minecart": "Vozík s truhlicou",
  "item.minecraft.chicken": "Surové kurča",
  "item.minecraft.chicken_spawn_egg": "Vajíčko so sliepkou",
  "item.minecraft.chorus_fruit": "Chorus",
  "item.minecraft.clay_ball": "Hrudka ílu",
  "item.minecraft.clock": "Hodinky",
  "item.minecraft.coal": "Uhlie",
  "item.minecraft.coast_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornament pobrežia",
  "item.minecraft.cocoa_beans": "Kakaové bôby",
  "item.minecraft.cod": "Surová treska",
  "item.minecraft.cod_bucket": "Vedro s treskou",
  "item.minecraft.cod_spawn_egg": "Vajíčko s treskou",
  "item.minecraft.command_block_minecart": "Vozík s príkazovou kockou",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Hovädzí rezeň",
  "item.minecraft.cooked_chicken": "Pečené kurča",
  "item.minecraft.cooked_cod": "Pečená treska",
  "item.minecraft.cooked_mutton": "Pečená baranina",
  "item.minecraft.cooked_porkchop": "Pečené bravčové",
  "item.minecraft.cooked_rabbit": "Pečený králik",
  "item.minecraft.cooked_salmon": "Pečený losos",
  "item.minecraft.cookie": "Sušienka",
  "item.minecraft.copper_axe": "Medená sekera",
  "item.minecraft.copper_boots": "Medené topánky",
  "item.minecraft.copper_chestplate": "Medené brnenie",
  "item.minecraft.copper_golem_spawn_egg": "Vajíčko s medeným golemom",
  "item.minecraft.copper_helmet": "Medená prilba",
  "item.minecraft.copper_hoe": "Medená motyka",
  "item.minecraft.copper_horse_armor": "Medená konská zbroj",
  "item.minecraft.copper_ingot": "Medená tehlička",
  "item.minecraft.copper_leggings": "Medené nohavice",
  "item.minecraft.copper_nautilus_armor": "Medené brnenie lodienky",
  "item.minecraft.copper_nugget": "Medený nuget",
  "item.minecraft.copper_pickaxe": "Medený krompáč",
  "item.minecraft.copper_shovel": "Medená lopata",
  "item.minecraft.copper_spear": "Medená kopija",
  "item.minecraft.copper_sword": "Medený meč",
  "item.minecraft.cow_spawn_egg": "Vajíčko s kravou",
  "item.minecraft.creaking_spawn_egg": "Vajíčko so škripotom",
  "item.minecraft.creeper_banner_pattern": "Vzor zástavy",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Vzor zástavy: creeper",
  "item.minecraft.creeper_spawn_egg": "Vajíčko s creeperom",
  "item.minecraft.crossbow": "Kuša",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Tyrkysový balíček",
  "item.minecraft.cyan_dye": "Tyrkysové farbivo",
  "item.minecraft.cyan_harness": "Tyrkysový postroj",
  "item.minecraft.danger_pottery_shard": "Črep nebezpečenstva",
  "item.minecraft.danger_pottery_sherd": "Črep nebezpečenstva",
  "item.minecraft.dark_oak_boat": "Čln z tmavého dubu",
  "item.minecraft.dark_oak_chest_boat": "Čln z tmavého dubu s truhlicou",
  "item.minecraft.debug_stick": "Ladiaca palica",
  "item.minecraft.debug_stick.empty": "%s nemá žiadne vlastnosti",
  "item.minecraft.debug_stick.select": "vybrané \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" bolo zmenené na %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantová sekera",
  "item.minecraft.diamond_boots": "Diamantové topánky",
  "item.minecraft.diamond_chestplate": "Diamantové brnenie",
  "item.minecraft.diamond_helmet": "Diamantová prilba",
  "item.minecraft.diamond_hoe": "Diamantová motyka",
  "item.minecraft.diamond_horse_armor": "Diamantová konská zbroj",
  "item.minecraft.diamond_leggings": "Diamantové nohavice",
  "item.minecraft.diamond_nautilus_armor": "Diamantové brnenie lodienky",
  "item.minecraft.diamond_pickaxe": "Diamantový krompáč",
  "item.minecraft.diamond_shovel": "Diamantová lopata",
  "item.minecraft.diamond_spear": "Diamantová kopija",
  "item.minecraft.diamond_sword": "Diamantový meč",
  "item.minecraft.disc_fragment_5": "Úlomok platne",
  "item.minecraft.disc_fragment_5.desc": "Hudobná platňa - 5",
  "item.minecraft.dolphin_spawn_egg": "Vajíčko s delfínom",
  "item.minecraft.donkey_spawn_egg": "Vajíčko so somárom",
  "item.minecraft.dragon_breath": "Dračí dych",
  "item.minecraft.dried_kelp": "Sušená chaluha",
  "item.minecraft.drowned_spawn_egg": "Vajíčko s utopencom",
  "item.minecraft.dune_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornament duny",
  "item.minecraft.echo_shard": "Úlomok ozveny",
  "item.minecraft.egg": "Vajce",
  "item.minecraft.elder_guardian_spawn_egg": "Vajíčko s prastrážcom",
  "item.minecraft.elytra": "Krovky",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Očarovaná kniha",
  "item.minecraft.enchanted_golden_apple": "Očarované zlaté jablko",
  "item.minecraft.end_crystal": "Endový kryštál",
  "item.minecraft.ender_dragon_spawn_egg": "Vajíčko s Ender drakom",
  "item.minecraft.ender_eye": "Ender oko",
  "item.minecraft.ender_pearl": "Ender perla",
  "item.minecraft.enderman_spawn_egg": "Vajíčko s endermanom",
  "item.minecraft.endermite_spawn_egg": "Vajíčko s endermitom",
  "item.minecraft.evoker_spawn_egg": "Vajíčko s vyvolávačom",
  "item.minecraft.experience_bottle": "Čarovná fľaša",
  "item.minecraft.explorer_pottery_shard": "Črep objaviteľa",
  "item.minecraft.explorer_pottery_sherd": "Črep objaviteľa",
  "item.minecraft.eye_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornament oka",
  "item.minecraft.feather": "Pierko",
  "item.minecraft.fermented_spider_eye": "Kvasené pavúčie oko",
  "item.minecraft.field_masoned_banner_pattern": "Vzor zástavy: murované pole",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Ohnivá strela",
  "item.minecraft.firework_rocket": "Ohňostroj",
  "item.minecraft.firework_rocket.flight": "Dĺžka letu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Ohňostrojová hviezda",
  "item.minecraft.firework_star.black": "Čierna",
  "item.minecraft.firework_star.blue": "Modrá",
  "item.minecraft.firework_star.brown": "Hnedá",
  "item.minecraft.firework_star.custom_color": "Vlastná",
  "item.minecraft.firework_star.cyan": "Tyrkysová",
  "item.minecraft.firework_star.fade_to": "Prechod do",
  "item.minecraft.firework_star.flicker": "Žmurknutie",
  "item.minecraft.firework_star.gray": "Sivá",
  "item.minecraft.firework_star.green": "Zelená",
  "item.minecraft.firework_star.light_blue": "Svetlomodrá",
  "item.minecraft.firework_star.light_gray": "Svetlosivá",
  "item.minecraft.firework_star.lime": "Svetlozelená",
  "item.minecraft.firework_star.magenta": "Purpurová",
  "item.minecraft.firework_star.orange": "Oranžová",
  "item.minecraft.firework_star.pink": "Ružová",
  "item.minecraft.firework_star.purple": "Fialová",
  "item.minecraft.firework_star.red": "Červená",
  "item.minecraft.firework_star.shape": "Neznámy tvar",
  "item.minecraft.firework_star.shape.burst": "Puknutie",
  "item.minecraft.firework_star.shape.creeper": "V tvare creepera",
  "item.minecraft.firework_star.shape.large_ball": "Veľká guľa",
  "item.minecraft.firework_star.shape.small_ball": "Malá guľa",
  "item.minecraft.firework_star.shape.star": "V tvare hviezdy",
  "item.minecraft.firework_star.trail": "Čiara",
  "item.minecraft.firework_star.white": "Biela",
  "item.minecraft.firework_star.yellow": "Žltá",
  "item.minecraft.fishing_rod": "Udica",
  "item.minecraft.flint": "Pazúrik",
  "item.minecraft.flint_and_steel": "Kresadlo",
  "item.minecraft.flow_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornament toku",
  "item.minecraft.flow_banner_pattern": "Vzor zástavy",
  "item.minecraft.flow_banner_pattern.desc": "Tok",
  "item.minecraft.flow_banner_pattern.new": "Vzor zástavy: tok",
  "item.minecraft.flow_pottery_sherd": "Črep toku",
  "item.minecraft.flower_banner_pattern": "Vzor zástavy",
  "item.minecraft.flower_banner_pattern.desc": "Kvet",
  "item.minecraft.flower_banner_pattern.new": "Vzor zástavy: kvet",
  "item.minecraft.flower_pot": "Kvetináč",
  "item.minecraft.fox_spawn_egg": "Vajíčko s líškou",
  "item.minecraft.friend_pottery_shard": "Priateľský črep",
  "item.minecraft.friend_pottery_sherd": "Črep priateľa",
  "item.minecraft.frog_spawn_egg": "Vajíčko so žabou",
  "item.minecraft.furnace_minecart": "Vozík s pecou",
  "item.minecraft.ghast_spawn_egg": "Vajíčko s ghastom",
  "item.minecraft.ghast_tear": "Slza ghasta",
  "item.minecraft.glass_bottle": "Sklenená fľaša",
  "item.minecraft.glistering_melon_slice": "Trblietavý melón",
  "item.minecraft.globe_banner_pattern": "Vzor zástavy",
  "item.minecraft.globe_banner_pattern.desc": "Glóbus",
  "item.minecraft.globe_banner_pattern.new": "Vzor zástavy: glóbus",
  "item.minecraft.glow_berries": "Svietiace bobule",
  "item.minecraft.glow_ink_sac": "Váčok žiariaceho atramentu",
  "item.minecraft.glow_item_frame": "Žiariaci rám",
  "item.minecraft.glow_squid_spawn_egg": "Vajíčko so žiariacou chobotnicou",
  "item.minecraft.glowstone_dust": "Svietivcový prach",
  "item.minecraft.goat_horn": "Kozí roh",
  "item.minecraft.goat_spawn_egg": "Vajíčko s kozou",
  "item.minecraft.gold_ingot": "Zlatá tehlička",
  "item.minecraft.gold_nugget": "Zlatý nuget",
  "item.minecraft.golden_apple": "Zlaté jablko",
  "item.minecraft.golden_axe": "Zlatá sekera",
  "item.minecraft.golden_boots": "Zlaté topánky",
  "item.minecraft.golden_carrot": "Zlatá mrkva",
  "item.minecraft.golden_chestplate": "Zlaté brnenie",
  "item.minecraft.golden_helmet": "Zlatá prilba",
  "item.minecraft.golden_hoe": "Zlatá motyka",
  "item.minecraft.golden_horse_armor": "Zlatá konská zbroj",
  "item.minecraft.golden_leggings": "Zlaté nohavice",
  "item.minecraft.golden_nautilus_armor": "Zlaté brnenie lodienky",
  "item.minecraft.golden_pickaxe": "Zlatý krompáč",
  "item.minecraft.golden_shovel": "Zlatá lopata",
  "item.minecraft.golden_spear": "Zlatá kopija",
  "item.minecraft.golden_sword": "Zlatý meč",
  "item.minecraft.gray_bundle": "Sivý balíček",
  "item.minecraft.gray_dye": "Sivé farbivo",
  "item.minecraft.gray_harness": "Sivý postroj",
  "item.minecraft.green_bundle": "Zelený balíček",
  "item.minecraft.green_dye": "Zelené farbivo",
  "item.minecraft.green_harness": "Zelený postroj",
  "item.minecraft.guardian_spawn_egg": "Vajíčko so strážcom",
  "item.minecraft.gunpowder": "Pušný prach",
  "item.minecraft.guster_banner_pattern": "Vzor zástavy",
  "item.minecraft.guster_banner_pattern.desc": "Fujak",
  "item.minecraft.guster_banner_pattern.new": "Vzor zástavy: fujak",
  "item.minecraft.guster_pottery_sherd": "Črep s fujakom",
  "item.minecraft.happy_ghast_spawn_egg": "Vajíčko so šťastným ghastom",
  "item.minecraft.harness": "Postroj",
  "item.minecraft.heart_of_the_sea": "Srdce oceánu",
  "item.minecraft.heart_pottery_shard": "Črep so srdcom",
  "item.minecraft.heart_pottery_sherd": "Črep so srdcom",
  "item.minecraft.heartbreak_pottery_shard": "Črep zlomeného srdca",
  "item.minecraft.heartbreak_pottery_sherd": "Črep zlomeného srdca",
  "item.minecraft.hoglin_spawn_egg": "Vajíčko s hoglinom",
  "item.minecraft.honey_bottle": "Fľaša medu",
  "item.minecraft.honeycomb": "Medový plást",
  "item.minecraft.hopper_minecart": "Vozík s násypníkom",
  "item.minecraft.horse_spawn_egg": "Vajíčko s koňom",
  "item.minecraft.host_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornament hostiteľa",
  "item.minecraft.howl_pottery_shard": "Črep vytia",
  "item.minecraft.howl_pottery_sherd": "Črep vytia",
  "item.minecraft.husk_spawn_egg": "Vajíčko so zdochliakom",
  "item.minecraft.ink_sac": "Atramentový váčok",
  "item.minecraft.iron_axe": "Železná sekera",
  "item.minecraft.iron_boots": "Železné topánky",
  "item.minecraft.iron_chestplate": "Železné brnenie",
  "item.minecraft.iron_golem_spawn_egg": "Vajíčko so železným golemom",
  "item.minecraft.iron_helmet": "Železná prilba",
  "item.minecraft.iron_hoe": "Železná motyka",
  "item.minecraft.iron_horse_armor": "Železná konská zbroj",
  "item.minecraft.iron_ingot": "Železná tehlička",
  "item.minecraft.iron_leggings": "Železné nohavice",
  "item.minecraft.iron_nautilus_armor": "Železné brnenie lodienky",
  "item.minecraft.iron_nugget": "Železný nuget",
  "item.minecraft.iron_pickaxe": "Železný krompáč",
  "item.minecraft.iron_shovel": "Železná lopata",
  "item.minecraft.iron_spear": "Železná kopija",
  "item.minecraft.iron_sword": "Železný meč",
  "item.minecraft.item_frame": "Rám",
  "item.minecraft.jungle_boat": "Džungľový čln",
  "item.minecraft.jungle_chest_boat": "Džungľový čln s truhlicou",
  "item.minecraft.knowledge_book": "Kniha znalostí",
  "item.minecraft.lapis_lazuli": "Lazurit",
  "item.minecraft.lava_bucket": "Vedro lávy",
  "item.minecraft.lead": "Vôdzka",
  "item.minecraft.leather": "Koža",
  "item.minecraft.leather_boots": "Kožené topánky",
  "item.minecraft.leather_chestplate": "Kožená tunika",
  "item.minecraft.leather_helmet": "Kožená čiapka",
  "item.minecraft.leather_horse_armor": "Kožená konská zbroj",
  "item.minecraft.leather_leggings": "Kožené nohavice",
  "item.minecraft.light_blue_bundle": "Svetlomodrý balíček",
  "item.minecraft.light_blue_dye": "Svetlomodré farbivo",
  "item.minecraft.light_blue_harness": "Svetlomodrý postroj",
  "item.minecraft.light_gray_bundle": "Svetlosivý balíček",
  "item.minecraft.light_gray_dye": "Svetlosivé farbivo",
  "item.minecraft.light_gray_harness": "Svetlosivý postroj",
  "item.minecraft.lime_bundle": "Svetlozelený balíček",
  "item.minecraft.lime_dye": "Svetlozelené farbivo",
  "item.minecraft.lime_harness": "Svetlozelený postroj",
  "item.minecraft.lingering_potion": "Plynný elixír",
  "item.minecraft.lingering_potion.effect.awkward": "Plynný trpký elixír",
  "item.minecraft.lingering_potion.effect.empty": "Plynný nevytvoriteľný elixír",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Plynný elixír ohňovzdornosti",
  "item.minecraft.lingering_potion.effect.harming": "Plynný elixír zranenia",
  "item.minecraft.lingering_potion.effect.healing": "Plynný elixír liečenia",
  "item.minecraft.lingering_potion.effect.infested": "Plynný elixír zamorenia",
  "item.minecraft.lingering_potion.effect.invisibility": "Plynný elixír neviditeľnosti",
  "item.minecraft.lingering_potion.effect.leaping": "Plynný elixír skákania",
  "item.minecraft.lingering_potion.effect.levitation": "Plynný elixír levitácie",
  "item.minecraft.lingering_potion.effect.luck": "Plynný elixír šťastia",
  "item.minecraft.lingering_potion.effect.mundane": "Plynný svetský elixír",
  "item.minecraft.lingering_potion.effect.night_vision": "Plynný elixír nočného videnia",
  "item.minecraft.lingering_potion.effect.oozing": "Plynný elixír vytekania",
  "item.minecraft.lingering_potion.effect.poison": "Plynný elixír otravy",
  "item.minecraft.lingering_potion.effect.regeneration": "Plynný elixír regenerácie",
  "item.minecraft.lingering_potion.effect.slow_falling": "Plynný elixír spomaleného pádu",
  "item.minecraft.lingering_potion.effect.slowness": "Plynný elixír spomalenia",
  "item.minecraft.lingering_potion.effect.strength": "Plynný elixír sily",
  "item.minecraft.lingering_potion.effect.swiftness": "Plynný elixír svižnosti",
  "item.minecraft.lingering_potion.effect.thick": "Plynný mohutný elixír",
  "item.minecraft.lingering_potion.effect.turtle_master": "Plynný elixír korytnačieho majstra",
  "item.minecraft.lingering_potion.effect.water": "Fľaša pary",
  "item.minecraft.lingering_potion.effect.water_breathing": "Plynný elixír dýchania pod vodou",
  "item.minecraft.lingering_potion.effect.weakness": "Plynný elixír slabosti",
  "item.minecraft.lingering_potion.effect.weaving": "Plynný elixír tkania",
  "item.minecraft.lingering_potion.effect.wind_charged": "Plynný elixír veterného nabitia",
  "item.minecraft.llama_spawn_egg": "Vajíčko s lamou",
  "item.minecraft.lodestone_compass": "Zmagnetizovaný kompas",
  "item.minecraft.mace": "Palcát",
  "item.minecraft.magenta_bundle": "Purpurový balíček",
  "item.minecraft.magenta_dye": "Purpurové farbivo",
  "item.minecraft.magenta_harness": "Purpurový postroj",
  "item.minecraft.magma_cream": "Magmový krém",
  "item.minecraft.magma_cube_spawn_egg": "Vajíčko s magmovým slizákom",
  "item.minecraft.mangrove_boat": "Mangrovový čln",
  "item.minecraft.mangrove_chest_boat": "Mangrovový čln s truhlicou",
  "item.minecraft.map": "Prázdna mapa",
  "item.minecraft.melon_seeds": "Semienka melóna",
  "item.minecraft.melon_slice": "Plátok melónu",
  "item.minecraft.milk_bucket": "Vedro mlieka",
  "item.minecraft.minecart": "Vozík",
  "item.minecraft.miner_pottery_shard": "Črep baníctva",
  "item.minecraft.miner_pottery_sherd": "Črep baníctva",
  "item.minecraft.mojang_banner_pattern": "Vzor zástavy",
  "item.minecraft.mojang_banner_pattern.desc": "Vecička",
  "item.minecraft.mojang_banner_pattern.new": "Vzor zástavy: vecička",
  "item.minecraft.mooshroom_spawn_egg": "Vajíčko s mooshroomom",
  "item.minecraft.mourner_pottery_shard": "Črep zármutku",
  "item.minecraft.mourner_pottery_sherd": "Črep zármutku",
  "item.minecraft.mule_spawn_egg": "Vajíčko s mulicou",
  "item.minecraft.mushroom_stew": "Hubová polievka",
  "item.minecraft.music_disc_11": "Hudobná platňa",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Hudobná platňa",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Hudobná platňa",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Hudobná platňa",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Hudobná platňa",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Hudobná platňa",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Hudobná platňa",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Hudobná platňa",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Hracia skrinka)",
  "item.minecraft.music_disc_far": "Hudobná platňa",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Hudobná platňa",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Hudobná platňa",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Hudobná platňa",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Hudobná platňa",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Hudobná platňa",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Hudobná platňa",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Hudobná platňa",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Hudobná platňa",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Hudobná platňa",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Hudobná platňa",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Hudobná platňa",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Hudobná platňa",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Surová baranina",
  "item.minecraft.name_tag": "Menovka",
  "item.minecraft.nautilus_shell": "Ulita lodienky",
  "item.minecraft.nautilus_spawn_egg": "Vajíčko s lodienkou",
  "item.minecraft.nether_brick": "Nether tehla",
  "item.minecraft.nether_star": "Nether hviezda",
  "item.minecraft.nether_wart": "Nether bradavica",
  "item.minecraft.netherite_axe": "Netheritová sekera",
  "item.minecraft.netherite_boots": "Netheritové topánky",
  "item.minecraft.netherite_chestplate": "Netheritové brnenie",
  "item.minecraft.netherite_helmet": "Netheritová prilba",
  "item.minecraft.netherite_hoe": "Netheritová motyka",
  "item.minecraft.netherite_horse_armor": "Netheritová konská zbroj",
  "item.minecraft.netherite_ingot": "Netheritová tehlička",
  "item.minecraft.netherite_leggings": "Netheritové nohavice",
  "item.minecraft.netherite_nautilus_armor": "Netheritové brnenie lodienky",
  "item.minecraft.netherite_pickaxe": "Netheritový krompáč",
  "item.minecraft.netherite_scrap": "Netheritový šrot",
  "item.minecraft.netherite_shovel": "Netheritová lopata",
  "item.minecraft.netherite_spear": "Netheritová kopija",
  "item.minecraft.netherite_sword": "Netheritový meč",
  "item.minecraft.netherite_upgrade_smithing_template": "Kováčska predloha",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritové vylepšenie",
  "item.minecraft.oak_boat": "Dubový čln",
  "item.minecraft.oak_chest_boat": "Dubový čln s truhlicou",
  "item.minecraft.ocelot_spawn_egg": "Vajíčko s ocelotom",
  "item.minecraft.ominous_bottle": "Zlovestná fľaša",
  "item.minecraft.ominous_trial_key": "Zlovestný kľúč skúšky",
  "item.minecraft.orange_bundle": "Oranžový balíček",
  "item.minecraft.orange_dye": "Oranžové farbivo",
  "item.minecraft.orange_harness": "Oranžový postroj",
  "item.minecraft.painting": "Obraz",
  "item.minecraft.pale_oak_boat": "Čln z bledého dubu",
  "item.minecraft.pale_oak_chest_boat": "Čln z bledého dubu s truhlicou",
  "item.minecraft.panda_spawn_egg": "Vajíčko s pandou",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Vajíčko so suchárom",
  "item.minecraft.parrot_spawn_egg": "Vajíčko s papagájom",
  "item.minecraft.phantom_membrane": "Koža prízraku",
  "item.minecraft.phantom_spawn_egg": "Vajíčko s prízrakom",
  "item.minecraft.pig_spawn_egg": "Vajíčko s prasaťom",
  "item.minecraft.piglin_banner_pattern": "Vzor zástavy",
  "item.minecraft.piglin_banner_pattern.desc": "Rypák",
  "item.minecraft.piglin_banner_pattern.new": "Vzor zástavy: rypák",
  "item.minecraft.piglin_brute_spawn_egg": "Vajíčko s barbarským piglinom",
  "item.minecraft.piglin_spawn_egg": "Vajíčko s piglinom",
  "item.minecraft.pillager_spawn_egg": "Vajíčko so zbojníkom",
  "item.minecraft.pink_bundle": "Ružový balíček",
  "item.minecraft.pink_dye": "Ružové farbivo",
  "item.minecraft.pink_harness": "Ružový postroj",
  "item.minecraft.pitcher_plant": "Džbánovník",
  "item.minecraft.pitcher_pod": "Sadenica džbánovníka",
  "item.minecraft.plenty_pottery_shard": "Črep hojnosti",
  "item.minecraft.plenty_pottery_sherd": "Črep hojnosti",
  "item.minecraft.poisonous_potato": "Jedovatý zemiak",
  "item.minecraft.polar_bear_spawn_egg": "Vajíčko s polárnym medveďom",
  "item.minecraft.popped_chorus_fruit": "Vyklíčený chorus",
  "item.minecraft.porkchop": "Surové bravčové",
  "item.minecraft.potato": "Zemiak",
  "item.minecraft.potion": "Elixír",
  "item.minecraft.potion.effect.awkward": "Trpký elixír",
  "item.minecraft.potion.effect.empty": "Nevytvoriteľný elixír",
  "item.minecraft.potion.effect.fire_resistance": "Elixír ohňovzdornosti",
  "item.minecraft.potion.effect.harming": "Elixír zranenia",
  "item.minecraft.potion.effect.healing": "Elixír liečenia",
  "item.minecraft.potion.effect.infested": "Elixír zamorenia",
  "item.minecraft.potion.effect.invisibility": "Elixír neviditeľnosti",
  "item.minecraft.potion.effect.leaping": "Elixír skákania",
  "item.minecraft.potion.effect.levitation": "Elixír levitácie",
  "item.minecraft.potion.effect.luck": "Elixír šťastia",
  "item.minecraft.potion.effect.mundane": "Svetský elixír",
  "item.minecraft.potion.effect.night_vision": "Elixír nočného videnia",
  "item.minecraft.potion.effect.oozing": "Elixír vytekania",
  "item.minecraft.potion.effect.poison": "Elixír otravy",
  "item.minecraft.potion.effect.regeneration": "Elixír regenerácie",
  "item.minecraft.potion.effect.slow_falling": "Elixír spomaleného pádu",
  "item.minecraft.potion.effect.slowness": "Elixír spomalenia",
  "item.minecraft.potion.effect.strength": "Elixír sily",
  "item.minecraft.potion.effect.swiftness": "Elixír svižnosti",
  "item.minecraft.potion.effect.thick": "Mohutný elixír",
  "item.minecraft.potion.effect.turtle_master": "Elixír korytnačieho majstra",
  "item.minecraft.potion.effect.water": "Fľaša vody",
  "item.minecraft.potion.effect.water_breathing": "Elixír dýchania pod vodou",
  "item.minecraft.potion.effect.weakness": "Elixír slabosti",
  "item.minecraft.potion.effect.weaving": "Elixír tkania",
  "item.minecraft.potion.effect.wind_charged": "Elixír veterného nabitia",
  "item.minecraft.pottery_shard_archer": "Črep s lukom",
  "item.minecraft.pottery_shard_arms_up": "Črep s rukami nad hlavou",
  "item.minecraft.pottery_shard_prize": "Črep s výhrou",
  "item.minecraft.pottery_shard_skull": "Črep s lebkou",
  "item.minecraft.powder_snow_bucket": "Vedro prašného snehu",
  "item.minecraft.prismarine_crystals": "Prizmarínové kryštály",
  "item.minecraft.prismarine_shard": "Prizmarínový črep",
  "item.minecraft.prize_pottery_shard": "Diamantový črep",
  "item.minecraft.prize_pottery_sherd": "Črep s diamantom",
  "item.minecraft.pufferfish": "Štvorzubec",
  "item.minecraft.pufferfish_bucket": "Vedro so štvorzubcom",
  "item.minecraft.pufferfish_spawn_egg": "Vajíčko so štvorzubcom",
  "item.minecraft.pumpkin_pie": "Tekvicový koláč",
  "item.minecraft.pumpkin_seeds": "Semienka tekvice",
  "item.minecraft.purple_bundle": "Fialový balíček",
  "item.minecraft.purple_dye": "Fialové farbivo",
  "item.minecraft.purple_harness": "Fialový postroj",
  "item.minecraft.quartz": "Nether kremeň",
  "item.minecraft.rabbit": "Surový králik",
  "item.minecraft.rabbit_foot": "Králičia labka",
  "item.minecraft.rabbit_hide": "Králičia koža",
  "item.minecraft.rabbit_spawn_egg": "Vajíčko s králikom",
  "item.minecraft.rabbit_stew": "Králičí guláš",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornament chovateľa",
  "item.minecraft.ravager_spawn_egg": "Vajíčko s ničiteľom",
  "item.minecraft.raw_copper": "Hruda medi",
  "item.minecraft.raw_gold": "Hruda zlata",
  "item.minecraft.raw_iron": "Hruda železa",
  "item.minecraft.recovery_compass": "Kompas návratu",
  "item.minecraft.red_bundle": "Červený balíček",
  "item.minecraft.red_dye": "Červené farbivo",
  "item.minecraft.red_harness": "Červený postroj",
  "item.minecraft.redstone": "Redstonový prach",
  "item.minecraft.resin_brick": "Živicová tehla",
  "item.minecraft.resin_clump": "Hrudka živice",
  "item.minecraft.rib_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornament rebra",
  "item.minecraft.rotten_flesh": "Zhnité mäso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Surový losos",
  "item.minecraft.salmon_bucket": "Vedro s lososom",
  "item.minecraft.salmon_spawn_egg": "Vajíčko s lososom",
  "item.minecraft.scrape_pottery_sherd": "Črep so sekerou",
  "item.minecraft.scute": "Doštička",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornament stráže",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornament ohýbača",
  "item.minecraft.sheaf_pottery_shard": "Črep so zväzkom",
  "item.minecraft.sheaf_pottery_sherd": "Črep so zväzkom",
  "item.minecraft.shears": "Nožnice",
  "item.minecraft.sheep_spawn_egg": "Vajíčko s ovcou",
  "item.minecraft.shelter_pottery_shard": "Črep s prístreškom",
  "item.minecraft.shelter_pottery_sherd": "Črep s prístreškom",
  "item.minecraft.shield": "Štít",
  "item.minecraft.shield.black": "Čierny štít",
  "item.minecraft.shield.blue": "Modrý štít",
  "item.minecraft.shield.brown": "Hnedý štít",
  "item.minecraft.shield.cyan": "Tyrkysový štít",
  "item.minecraft.shield.gray": "Sivý štít",
  "item.minecraft.shield.green": "Zelený štít",
  "item.minecraft.shield.light_blue": "Svetlomodrý štít",
  "item.minecraft.shield.light_gray": "Svetlosivý štít",
  "item.minecraft.shield.lime": "Svetlozelený štít",
  "item.minecraft.shield.magenta": "Purpurový štít",
  "item.minecraft.shield.orange": "Oranžový štít",
  "item.minecraft.shield.pink": "Ružový štít",
  "item.minecraft.shield.purple": "Fialový štít",
  "item.minecraft.shield.red": "Červený štít",
  "item.minecraft.shield.white": "Biely štít",
  "item.minecraft.shield.yellow": "Žltý štít",
  "item.minecraft.shulker_shell": "Shulkerov pancier",
  "item.minecraft.shulker_spawn_egg": "Vajíčko so shulkerom",
  "item.minecraft.sign": "Ceduľa",
  "item.minecraft.silence_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornament ticha",
  "item.minecraft.silverfish_spawn_egg": "Vajíčko so švehlou",
  "item.minecraft.skeleton_horse_spawn_egg": "Vajíčko s kostlivým koňom",
  "item.minecraft.skeleton_spawn_egg": "Vajíčko s kostlivcom",
  "item.minecraft.skull_banner_pattern": "Vzor zástavy",
  "item.minecraft.skull_banner_pattern.desc": "Lebka",
  "item.minecraft.skull_banner_pattern.new": "Vzor zástavy: lebka",
  "item.minecraft.skull_pottery_shard": "Črep smrti",
  "item.minecraft.skull_pottery_sherd": "Črep smrti",
  "item.minecraft.slime_ball": "Sliz",
  "item.minecraft.slime_spawn_egg": "Vajíčko so slizákom",
  "item.minecraft.smithing_template": "Kováčska predloha",
  "item.minecraft.smithing_template.applies_to": "Vhodné na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Pridaj tehličku alebo kryštál",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Brnenie",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Pridaj kus brnenia",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Tehličky a kryštály",
  "item.minecraft.smithing_template.ingredients": "Ingrediencie:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Pridaj netheritovú tehličku",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantový výstroj",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Pridaj diamantové brnenie, zbraň alebo nástroj",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritová tehlička",
  "item.minecraft.smithing_template.upgrade": "Vylepšenie: ",
  "item.minecraft.sniffer_spawn_egg": "Vajíčko s ňuchačom",
  "item.minecraft.snort_pottery_shard": "Črep ňuchača",
  "item.minecraft.snort_pottery_sherd": "Črep ňuchača",
  "item.minecraft.snout_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornament rypáka",
  "item.minecraft.snow_golem_spawn_egg": "Vajíčko so snehuliakom",
  "item.minecraft.snowball": "Snehová guľa",
  "item.minecraft.spectral_arrow": "Žiariaci šíp",
  "item.minecraft.spider_eye": "Pavúčie oko",
  "item.minecraft.spider_spawn_egg": "Vajíčko s pavúkom",
  "item.minecraft.spire_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornament veže",
  "item.minecraft.splash_potion": "Hádzací elixír",
  "item.minecraft.splash_potion.effect.awkward": "Hádzací trpký elixír",
  "item.minecraft.splash_potion.effect.empty": "Hádzací nevytvoriteľný elixír",
  "item.minecraft.splash_potion.effect.fire_resistance": "Hádzací elixír ohňovzdornosti",
  "item.minecraft.splash_potion.effect.harming": "Hádzací elixír zranenia",
  "item.minecraft.splash_potion.effect.healing": "Hádzací elixír liečenia",
  "item.minecraft.splash_potion.effect.infested": "Hádzací elixír zamorenia",
  "item.minecraft.splash_potion.effect.invisibility": "Hádzací elixír neviditeľnosti",
  "item.minecraft.splash_potion.effect.leaping": "Hádzací elixír skákania",
  "item.minecraft.splash_potion.effect.levitation": "Hádzací elixír levitácie",
  "item.minecraft.splash_potion.effect.luck": "Hádzací elixír šťastia",
  "item.minecraft.splash_potion.effect.mundane": "Hádzací svetský elixír",
  "item.minecraft.splash_potion.effect.night_vision": "Hádzací elixír nočného videnia",
  "item.minecraft.splash_potion.effect.oozing": "Hádzací elixír vytekania",
  "item.minecraft.splash_potion.effect.poison": "Hádzací elixír otravy",
  "item.minecraft.splash_potion.effect.regeneration": "Hádzací elixír regenerácie",
  "item.minecraft.splash_potion.effect.slow_falling": "Hádzací elixír spomaleného pádu",
  "item.minecraft.splash_potion.effect.slowness": "Hádzací elixír spomalenia",
  "item.minecraft.splash_potion.effect.strength": "Hádzací elixír sily",
  "item.minecraft.splash_potion.effect.swiftness": "Hádzací elixír svižnosti",
  "item.minecraft.splash_potion.effect.thick": "Hádzací mohutný elixír",
  "item.minecraft.splash_potion.effect.turtle_master": "Hádzací elixír korytnačieho majstra",
  "item.minecraft.splash_potion.effect.water": "Hádzacia fľaša vody",
  "item.minecraft.splash_potion.effect.water_breathing": "Hádzací elixír dýchania pod vodou",
  "item.minecraft.splash_potion.effect.weakness": "Hádzací elixír slabosti",
  "item.minecraft.splash_potion.effect.weaving": "Hádzací elixír tkania",
  "item.minecraft.splash_potion.effect.wind_charged": "Hádzací elixír veterného nabitia",
  "item.minecraft.spruce_boat": "Smrekový čln",
  "item.minecraft.spruce_chest_boat": "Smrekový čln s truhlicou",
  "item.minecraft.spyglass": "Ďalekohľad",
  "item.minecraft.squid_spawn_egg": "Vajíčko s chobotnicou",
  "item.minecraft.stick": "Palica",
  "item.minecraft.stone_axe": "Kamenná sekera",
  "item.minecraft.stone_hoe": "Kamenná motyka",
  "item.minecraft.stone_pickaxe": "Kamenný krompáč",
  "item.minecraft.stone_shovel": "Kamenná lopata",
  "item.minecraft.stone_spear": "Kamenná kopija",
  "item.minecraft.stone_sword": "Kamenný meč",
  "item.minecraft.stray_spawn_egg": "Vajíčko s tulákom",
  "item.minecraft.strider_spawn_egg": "Vajíčko s lávochodom",
  "item.minecraft.string": "Vlákno",
  "item.minecraft.sugar": "Cukor",
  "item.minecraft.suspicious_stew": "Podozrivá brečka",
  "item.minecraft.sweet_berries": "Sladké bobule",
  "item.minecraft.tadpole_bucket": "Vedro so žubrienkou",
  "item.minecraft.tadpole_spawn_egg": "Vajíčko so žubrienkou",
  "item.minecraft.tide_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornament prílivu",
  "item.minecraft.tipped_arrow": "Šíp s efektom",
  "item.minecraft.tipped_arrow.effect.awkward": "Šíp s Efektom",
  "item.minecraft.tipped_arrow.effect.empty": "Nevyrobiteľný šíp s efektom",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Šíp ohňovzdornosti",
  "item.minecraft.tipped_arrow.effect.harming": "Šíp zranenia",
  "item.minecraft.tipped_arrow.effect.healing": "Šíp liečenia",
  "item.minecraft.tipped_arrow.effect.infested": "Šíp zamorenia",
  "item.minecraft.tipped_arrow.effect.invisibility": "Šíp neviditeľnosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Šíp skákania",
  "item.minecraft.tipped_arrow.effect.levitation": "Šíp levitácie",
  "item.minecraft.tipped_arrow.effect.luck": "Šíp šťastia",
  "item.minecraft.tipped_arrow.effect.mundane": "Šíp s Efektom",
  "item.minecraft.tipped_arrow.effect.night_vision": "Šíp nočného videnia",
  "item.minecraft.tipped_arrow.effect.oozing": "Šíp vytekania",
  "item.minecraft.tipped_arrow.effect.poison": "Otrávený Šíp",
  "item.minecraft.tipped_arrow.effect.regeneration": "Šíp regenerácie",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Šíp spomaleného pádu",
  "item.minecraft.tipped_arrow.effect.slowness": "Šíp spomalenia",
  "item.minecraft.tipped_arrow.effect.strength": "Šíp sily",
  "item.minecraft.tipped_arrow.effect.swiftness": "Šíp svižnosti",
  "item.minecraft.tipped_arrow.effect.thick": "Šíp s Efektom",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Šíp korytnačieho majstra",
  "item.minecraft.tipped_arrow.effect.water": "Namočený šíp",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Šíp dýchania pod vodou",
  "item.minecraft.tipped_arrow.effect.weakness": "Šíp slabosti",
  "item.minecraft.tipped_arrow.effect.weaving": "Šíp tkania",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Šíp veterného nabitia",
  "item.minecraft.tnt_minecart": "Vozík s TNT",
  "item.minecraft.torchflower_seeds": "Semienka fakľovky",
  "item.minecraft.totem_of_undying": "Totem nesmrteľnosti",
  "item.minecraft.trader_llama_spawn_egg": "Vajíčko s obchodníckou lamou",
  "item.minecraft.trial_key": "Kľúč skúšky",
  "item.minecraft.trident": "Trojzubec",
  "item.minecraft.tropical_fish": "Tropická ryba",
  "item.minecraft.tropical_fish_bucket": "Vedro s tropickou rybou",
  "item.minecraft.tropical_fish_spawn_egg": "Vajíčko s tropickou rybou",
  "item.minecraft.turtle_helmet": "Korytnačí pancier",
  "item.minecraft.turtle_scute": "Korytnačia doštička",
  "item.minecraft.turtle_spawn_egg": "Vajíčko s korytnačkou",
  "item.minecraft.vex_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornament škodcu",
  "item.minecraft.vex_spawn_egg": "Vajíčko so škodcom",
  "item.minecraft.villager_spawn_egg": "Vajíčko s osadníkom",
  "item.minecraft.vindicator_spawn_egg": "Vajíčko s pomstiteľom",
  "item.minecraft.wandering_trader_spawn_egg": "Vajíčko s potulným obchodníkom",
  "item.minecraft.ward_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornament chránenca",
  "item.minecraft.warden_spawn_egg": "Vajíčko s vartášom",
  "item.minecraft.warped_fungus_on_a_stick": "Prízračná huba na udici",
  "item.minecraft.water_bucket": "Vedro vody",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornament sprievodcu",
  "item.minecraft.wheat": "Pšenica",
  "item.minecraft.wheat_seeds": "Semienka pšenice",
  "item.minecraft.white_bundle": "Biely balíček",
  "item.minecraft.white_dye": "Biele farbivo",
  "item.minecraft.white_harness": "Biely postroj",
  "item.minecraft.wild_armor_trim_smithing_template": "Kováčska predloha",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornament divočiny",
  "item.minecraft.wind_charge": "Veterný náboj",
  "item.minecraft.witch_spawn_egg": "Vajíčko s bosorkou",
  "item.minecraft.wither_skeleton_spawn_egg": "Vajíčko s Wither kostlivcom",
  "item.minecraft.wither_spawn_egg": "Vajíčko s Witherom",
  "item.minecraft.wolf_armor": "Vlčie brnenie",
  "item.minecraft.wolf_spawn_egg": "Vajíčko s vlkom",
  "item.minecraft.wooden_axe": "Drevená sekera",
  "item.minecraft.wooden_hoe": "Drevená motyka",
  "item.minecraft.wooden_pickaxe": "Drevený krompáč",
  "item.minecraft.wooden_shovel": "Drevená lopata",
  "item.minecraft.wooden_spear": "Drevená kopija",
  "item.minecraft.wooden_sword": "Drevený meč",
  "item.minecraft.writable_book": "Kniha a brko",
  "item.minecraft.written_book": "Napísaná kniha",
  "item.minecraft.yellow_bundle": "Žltý balíček",
  "item.minecraft.yellow_dye": "Žlté farbivo",
  "item.minecraft.yellow_harness": "Žltý postroj",
  "item.minecraft.zoglin_spawn_egg": "Vajíčko so zoglinom",
  "item.minecraft.zombie_horse_spawn_egg": "Vajíčko so zombie koňom",
  "item.minecraft.zombie_nautilus_spawn_egg": "Vajíčko so zombie lodienkou",
  "item.minecraft.zombie_spawn_egg": "Vajíčko so zombíkom",
  "item.minecraft.zombie_villager_spawn_egg": "Vajíčko so zombie osadníkom",
  "item.minecraft.zombified_piglin_spawn_egg": "Vajíčko so zombie piglinom"
}
export const sk_sk = items; 
